<template>
  <main class="rd-wrap">
    <div id="reserdetail">
      <section class="rd-section">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-12 col-lg-10">

              <!-- 페이지 헤더 -->
              <div class="rd-page-header">
                <div class="rd-header-badge">
                  <span style="font-size:1.1rem;">🗃️</span>
                  <span style="font-size:1.1rem; font-weight:800;" v-if="ctCode==='nbus'">NBUS</span>
                  <span style="font-size:1.1rem; font-weight:800;" v-else-if="ctCode==='H'">HOTEL</span>
                  <span style="font-size:1.1rem; font-weight:800;" v-else>TRIP / TICKET / PASS</span>
                </div>
                <h1 class="rd-page-title">비회원 예약 상세내역</h1>
                <p class="rd-page-sub">예약하신 내용을 확인하세요</p>
              </div>


              <!-- ============================
                호텔 예약 섹션
              ============================= -->
              <template v-if="ctCode === 'H'">

                <!-- ① 호텔 헤더 카드 -->
                <div class="rd-card rd-product-card">
                  <div style="width:100%; height:220px; overflow:hidden; background:#f0f4f8;">
                    <img v-if="hotelDetailInfo.heroImg"
                      :src="`${$store.state.rakutenImageHost}/${hotelBookingInfo.hotel_id}/${hotelDetailInfo.heroImg}`"
                      style="width:100%; height:220px; object-fit:cover; display:block;"
                      @error="e => e.target.style.display='none'" />
                    <div v-else style="width:100%; height:220px; display:flex; align-items:center; justify-content:center; font-size:3rem; background:#f0f4f8;">🏨</div>
                  </div>
                  <div style="padding:1.2rem 1.6rem; display:flex; align-items:center; gap:1rem; flex-wrap:wrap;">
                    <div style="flex:1;">
                      <div style="font-size:0.72rem; color:#888; font-weight:600; letter-spacing:.06em; margin-bottom:.2rem;">HOTEL BOOKING</div>
                      <div style="font-size:1.2rem; font-weight:800; color:#1a1a2e; margin-bottom:.2rem;">{{ hotelBookingInfo.hotel_name }}</div>
                      <div v-if="hotelDetailInfo.original_name" style="font-size:0.8rem; color:#888; margin-bottom:.4rem;">{{ hotelDetailInfo.original_name }}</div>
                      <div style="display:flex; align-items:center; gap:.6rem; flex-wrap:wrap;">
                        <span style="font-size:0.82rem; font-weight:700; color:#1a6eb5;">{{ hotelBookingInfo.booking_no }}</span>
                        <span :class="['status-badge-h', hotelStatusClass(hotelBookingInfo.status)]">
                          {{ hotelStatusText(hotelBookingInfo.status) }}
                        </span>
                      </div>
                    </div>
                    <div>
                      <button class="rd-action-btn" @click="goToCustomerAsk()">
                        <i class="bi bi-chat-dots"></i> 문의하기
                      </button>
                    </div>
                  </div>
                  <div style="background:#f0f4ff; padding:.75rem 1.4rem; border-top:1px solid #e2e8f0; display:flex; align-items:center; gap:1.2rem; flex-wrap:wrap; font-size:.85rem; color:#444;">
                    <span>📅 {{ getDateFormat(hotelBookingInfo.check_in) }} ~ {{ getDateFormat(hotelBookingInfo.check_out) }}</span>
                    <span style="color:#ddd;">|</span>
                    <span>🌙 {{ hotelBookingInfo.night_count }}박</span>
                    <span style="color:#ddd;">|</span>
                    <span>👥 성인 {{ hotelBookingInfo.adult_count }}명 · {{ hotelBookingInfo.room_count }}실</span>
                  </div>
                  <div v-if="hotelDetailInfo.latitude && hotelDetailInfo.longitude" style="border-top:1px solid #e2e8f0; border-radius:0 0 14px 14px; overflow:hidden;">
                    <div id="hotel-detail-map" style="width:100%; height:300px;"></div>
                  </div>
                </div>

                <!-- ② 예약 정보 -->
                <div class="rd-card">
                  <div class="rd-card-header">
                    <i class="bi bi-calendar-check"></i>
                    <span>예약 정보</span>
                  </div>
                  <div class="rd-card-body">
                    <div class="rd-info-grid">
                      <div class="rd-info-item">
                        <span class="rd-info-label">체크인</span>
                        <span class="rd-info-value" style="font-weight:700; color:#1a6eb5;">{{ getDateFormat(hotelBookingInfo.check_in) }}</span>
                      </div>
                      <div class="rd-info-item">
                        <span class="rd-info-label">체크아웃</span>
                        <span class="rd-info-value" style="font-weight:700; color:#1a6eb5;">{{ getDateFormat(hotelBookingInfo.check_out) }}</span>
                      </div>
                      <div class="rd-info-item">
                        <span class="rd-info-label">숙박 / 인원 / 객실</span>
                        <span class="rd-info-value">
                          {{ hotelBookingInfo.night_count }}박 /
                          성인 {{ hotelBookingInfo.adult_count }}명 /
                          {{ hotelBookingInfo.room_count }}실
                        </span>
                      </div>
                      <div class="rd-info-item">
                        <span class="rd-info-label">객실</span>
                        <span class="rd-info-value">{{ hotelBookingInfo.room_desc || '-' }}</span>
                      </div>
                      <!-- 호텔승인코드 -->
                      <div class="rd-info-item" v-if="hotelBookingInfo.hotel_conf_id">
                        <span class="rd-info-label">Hotel Confirmation ID</span>
                        <span class="rd-info-value" style="color:#2c7a4b; font-weight:700; font-size:1rem;">
                          {{ hotelBookingInfo.hotel_conf_id }}
                        </span>
                      </div>
                      <div class="rd-info-item rd-info-item--full" v-if="hotelBookingInfo.special_request">
                        <span class="rd-info-label">특별요청사항 &nbsp;<span style="color:red;">(※ 현지 참고용 전달사항으로 보장되지 않습니다)</span></span>
                        <span class="rd-info-value">{{ hotelBookingInfo.special_request }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- ③ 투숙객 정보 -->
                <div class="rd-card" v-if="hotelBookingGuests.length > 0">
                  <div class="rd-card-header">
                    <i class="bi bi-people"></i>
                    <span>투숙객 정보</span>
                  </div>
                  <div class="rd-card-body">
                    <div v-for="(g, i) in hotelBookingGuests" :key="i"
                      style="padding:.7rem 1rem; background:#f8f9ff; border-radius:8px; border:1px solid #e2e8f0; margin-bottom:.6rem;">
                      <div style="display:flex; align-items:center; gap:.6rem; font-size:.85rem;">
                        <span style="font-weight:700; color:#1a6eb5;">{{ i+1 }}호실</span>
                        <span style="font-weight:600; color:#1a1a2e;">{{ g.salutation }} {{ g.first_name }} {{ g.last_name }}</span>
                        <span style="font-size:.75rem; color:#888;">({{ g.nationality }})</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- ④ 예약자 정보 -->
                <div class="rd-card">
                  <div class="rd-card-header">
                    <i class="bi bi-person-circle"></i>
                    <span>예약자 정보</span>
                  </div>
                  <div class="rd-card-body">
                    <div class="rd-info-grid">
                      <div class="rd-info-item">
                        <span class="rd-info-label">성명</span>
                        <span class="rd-info-value">{{ hotelBookingInfo.contact_name }}</span>
                      </div>
                      <div class="rd-info-item">
                        <span class="rd-info-label">연락처</span>
                        <span class="rd-info-value">{{ hotelBookingInfo.contact_no }}</span>
                      </div>
                      <div class="rd-info-item rd-info-item--full">
                        <span class="rd-info-label">이메일</span>
                        <span class="rd-info-value">{{ hotelBookingInfo.contact_email }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- ⑤ 결제 정보 -->
                <div class="rd-card">
                  <div class="rd-card-header">
                    <i class="bi bi-credit-card"></i>
                    <span>결제 정보</span>
                  </div>
                  <div class="rd-card-body">
                    <div class="rd-pay-summary">
                      <div class="rd-pay-row rd-pay-row--total">
                        <span class="rd-pay-label fs-6">총결제금액</span>
                        <span class="rd-pay-value rd-pay-value--total">
                          {{ getCurrencyFormat(hotelBookingInfo.selling_krw) }}<em>원</em>
                        </span>
                      </div>
                      <div class="text-end text-secondary">
                        <span style="font-size:small;">( {{ getKorDateFormat(hotelBookingInfo.paidDate) }} )</span>
                      </div>
                    </div>

                    <!-- 취소정책 -->
                    <div v-if="hotelBookingInfo.cancel_remarks || cancelPolicyDetails.length > 0"
                      style="background:#fffbeb; border:1px solid #fde68a; border-radius:8px; padding:1rem 1.2rem; margin-top:.8rem;">
                      <div style="font-size:.82rem; font-weight:700; color:#b45309; margin-bottom:.6rem;">📋 취소정책</div>

                      <!-- ✅ v-if로 변경 (cancel_remarks 있어도 구간표 같이 표시) -->
                      <div v-if="hotelBookingInfo.cancel_remarks"
                          style="font-size:.82rem; color:#78350f; line-height:1.7; margin-bottom:.6rem;">
                        {{ hotelBookingInfo.cancel_remarks }}
                      </div>

                      <!-- ✅ v-else → v-if 로 변경 -->
                      <div v-if="cancelPolicyDetails.length > 0">
                        <div v-for="(p, i) in cancelPolicyDetails" :key="i"
                          :style="{
                            display:'flex', justifyContent:'space-between', alignItems:'center',
                            gap:'.8rem', padding:'.5rem .6rem', borderRadius:'6px',
                            background: p.isCurrent ? '#fff3cd' : 'transparent',
                            border: p.isCurrent ? '1px solid #f5c344' : '1px solid transparent',
                            marginBottom: i < cancelPolicyDetails.length - 1 ? '.3rem' : '0'
                          }">
                          <span style="font-size:.78rem; color:#78350f;">
                            {{ p.label }}
                            <span v-if="p.isCurrent" style="font-size:.7rem; font-weight:700; color:#b45309; margin-left:.4rem;">(현재 적용)</span>
                          </span>
                          <span :style="{ fontSize:'.8rem', fontWeight:'700', color: p.percentColor, whiteSpace:'nowrap' }">
                            {{ p.percentText }}
                          </span>
                        </div>
                        <p style="font-size:.72rem; color:#aaa; margin:.6rem 0 0;">※ 시간은 한국 표준시(KST) 기준입니다.</p>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- ⑥ 하단 버튼 -->
                <div class="rd-footer-btns">
                  <button type="button" class="rd-footer-btn rd-footer-btn--main" @click="$router.push('/')">
                    <i class="bi bi-house"></i> 홈으로
                  </button>
                  <button type="button" class="rd-footer-btn rd-footer-btn--cancel"
                    v-if="hotelBookingInfo.status === 'bkg-cf'"
                    @click="reqCancelHotel()" :disabled="hotelCancelLoading">
                    <i class="bi bi-x-circle"></i>
                    {{ hotelCancelLoading ? '처리 중...' : '예약 취소' }}
                  </button>
                  <button type="button" class="rd-footer-btn rd-footer-btn--cancel" disabled
                    v-else-if="hotelBookingInfo.status === 'bkg-cx'">
                    <i class="bi bi-check-circle"></i> 취소완료
                  </button>
                </div>

              </template>


              <!-- ============================
                엔버스 섹션
              ============================= -->
              <template v-else-if="ctCode === 'nbus'">

                <!-- 상품 헤더 카드 -->
                <div class="rd-card rd-product-card">
                  <div class="rd-nbus-header">
                    <div class="rd-nbus-icon">
                      <i class="bi bi-bus-front-fill"></i>
                    </div>
                    <div class="rd-nbus-info">
                      <p class="rd-label">엔버스 번호</p>
                      <p class="rd-nbus-code">{{ this.reserveInfo.inqCode }}</p>
                    </div>
                  </div>
                </div>

                <!-- 엔버스 일정 -->
                <div class="rd-card">
                  <div class="rd-card-header">
                    <i class="bi bi-map"></i>
                    <span>엔버스 일정 / 경로</span>
                  </div>
                  <div class="rd-card-body">
                    <!-- PC -->
                    <div class="pc">
                      <div class="rd-info-grid">
                        <div class="rd-info-item">
                          <span class="rd-info-label">출발일자 (이용일자)</span>
                          <span class="rd-info-value">
                            {{ this.getDateFormat(reserveInfo.rentStartDate) }}
                            <em class="rd-days">({{ reserveInfo.rentTotDays }}일간)</em>
                          </span>
                        </div>
                        <div class="rd-info-item">
                          <span class="rd-info-label">인원 / 가이드 / 버스</span>
                          <span class="rd-info-value">
                            {{ this.reserveInfo.personCnt }}인 / {{ reserveInfo.guideLv }} /
                            {{ reserveInfo.busLv }} ({{ reserveInfo.busDetail }})
                          </span>
                        </div>
                      </div>

                      <div class="rd-route-section">
                        <p class="rd-section-sub-title">
                          <i class="bi bi-signpost-split"></i> 일정 / 경로
                        </p>
                        <div :key="i" v-for="(rd, i) in exist_nbRoute" class="rd-route-item">
                          <div class="rd-route-day">{{ i+1 }}일차</div>
                          <div class="rd-route-points">
                            <span class="rd-route-dept">{{ rd.deptPoint }}</span>
                            <i class="bi bi-arrow-right rd-route-arrow"></i>
                            <span class="rd-route-via" v-if="rd.viaPoint">{{ rd.viaPoint }}</span>
                            <i class="bi bi-arrow-right rd-route-arrow" v-if="rd.viaPoint"></i>
                            <span class="rd-route-arr">{{ rd.arrPoint }}</span>
                          </div>
                          <div class="rd-route-time">
                            <i class="bi bi-clock"></i>
                            {{ rd.rentStartTime }} ~ {{ rd.rentCloseTime }}
                          </div>
                        </div>
                      </div>

                      <div class="rd-info-grid rd-mt">
                        <div class="rd-info-item rd-info-item--full">
                          <span class="rd-info-label">담당자 안내사항</span>
                          <textarea class="rd-textarea" v-model="reserveInfo.addComment" maxlength="1000" disabled></textarea>
                        </div>
                        <div class="rd-info-item">
                          <span class="rd-info-label">
                            예약상태
                            <small v-if="this.rpCode === 'nonWP'" class="rd-account-badge">(가상계좌)</small>
                          </span>
                          <div class="rd-status-wrap">
                            <div v-if="this.rpCode === 'nonWP'">
                              <span class="rd-status-badge rd-status--request">{{ this.accPayStatus }}</span>
                            </div>
                            <div v-else>
                              <span class="rd-status-badge rd-status--paid" v-if="this.payStyle === 'f'">전액결제완료 (담당매니저 확인 중)</span>
                              <span class="rd-status-badge rd-status--partial" v-else-if="this.payStyle === 'p'">부분결제완료 (담당매니저 확인 중)</span>
                              <span class="rd-status-badge rd-status--paid" v-if="this.reserveInfo.inqStatus === 'RP' && this.paidFlag == 'Y'">결제완료 (담당매니저 확인 중)</span>
                              <span class="rd-status-badge rd-status--request" v-else-if="this.reserveInfo.inqStatus === 'RP' && this.paidFlag != 'Y'">결제요청</span>
                              <span class="rd-status-badge rd-status--paid" v-else-if="this.reserveInfo.inqStatus === 'PY' && this.reserveInfo.firstPayment == null">결제완료 (담당매니저 확인 중)</span>
                              <span class="rd-status-badge rd-status--cancel" v-else-if="this.reserveInfo.reqStatus === 'CX'"><s>{{ this.reserveInfo.procName }}</s></span>
                              <span class="rd-status-text" v-else-if="this.payStyle != 'f' && this.payStyle != 'p'">{{ this.reserveInfo.procName }}</span>
                            </div>
                            <div v-if="this.cxlFlag === 'Y'">
                              <button type="button" class="rd-cxl-btn" @click="reqCxl_nbus(this.reserveInfo.inqCode)" disabled>취소요청 중</button>
                            </div>
                            <div v-else>
                              <button type="button" class="rd-cxl-btn" @click="reqCxl_nbus(this.reserveInfo.inqCode)">취소요청</button>
                            </div>
                          </div>
                        </div>
                        <div class="rd-info-item">
                          <span class="rd-info-label">예약안내사항</span>
                          <textarea class="rd-textarea" v-model="reserveInfo.supPrecaution" maxlength="5000" disabled></textarea>
                        </div>
                        <div class="rd-info-item">
                          <span class="rd-info-label">취소안내사항</span>
                          <textarea class="rd-textarea" v-model="reserveInfo.supCancellation" maxlength="5000" disabled></textarea>
                        </div>
                      </div>
                    </div>

                    <!-- 모바일 -->
                    <div class="mobile">
                      <div class="rd-info-list">
                        <div class="rd-info-row">
                          <span class="rd-info-label">출발일자</span>
                          <span class="rd-info-value">{{ this.getDateFormat(reserveInfo.rentStartDate) }} ({{ reserveInfo.rentTotDays }}일간)</span>
                        </div>
                        <div class="rd-info-row">
                          <span class="rd-info-label">인원/가이드/버스</span>
                          <span class="rd-info-value">{{ this.reserveInfo.personCnt }}인 / {{ reserveInfo.guideLv }} / {{ reserveInfo.busLv }} ({{ reserveInfo.busDetail }})</span>
                        </div>
                        <div class="rd-info-row rd-info-row--col">
                          <span class="rd-info-label">일정/경로</span>
                          <div :key="i" v-for="(rd, i) in exist_nbRoute" class="rd-route-item-mo">
                            <div class="rd-route-day-mo">{{ i+1 }} 일차</div>
                            <div class="rd-route-mo-grid">
                              <span class="rd-route-mo-label">출발지</span><span class="rd-route-dept">{{ rd.deptPoint }}</span>
                              <span class="rd-route-mo-label">경유지</span><span>{{ rd.viaPoint }}</span>
                              <span class="rd-route-mo-label">도착지</span><span class="rd-route-arr">{{ rd.arrPoint }}</span>
                              <span class="rd-route-mo-label">시작</span><span>{{ rd.rentStartTime }}</span>
                              <span class="rd-route-mo-label">종료</span><span>{{ rd.rentCloseTime }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="rd-info-row rd-info-row--col">
                          <span class="rd-info-label">
                            예약상태
                            <small v-if="this.rpCode === 'nonWP'" class="rd-account-badge">(가상계좌)</small>
                          </span>
                          <div class="rd-status-wrap">
                            <span class="rd-status-badge rd-status--paid" v-if="this.payStyle === 'f'">전액결제완료 (담당매니저 확인 중)</span>
                            <span class="rd-status-badge rd-status--partial" v-else-if="this.payStyle === 'p'">부분결제완료 (담당매니저 확인 중)</span>
                            <span class="rd-status-badge rd-status--paid" v-if="this.reserveInfo.inqStatus === 'RP' && this.paidFlag == 'Y'">결제완료 (담당매니저 확인 중)</span>
                            <span class="rd-status-badge rd-status--request" v-else-if="this.reserveInfo.inqStatus === 'RP' && this.paidFlag != 'Y'">결제요청</span>
                            <span class="rd-status-badge rd-status--paid" v-else-if="this.reserveInfo.inqStatus === 'PY' && this.reserveInfo.firstPayment == null">결제완료 (담당매니저 확인 중)</span>
                            <span class="rd-status-badge rd-status--cancel" v-else-if="this.reserveInfo.inqStatus === 'CX'"><s>{{ this.reserveInfo.procName }}</s></span>
                            <span class="rd-status-text" v-else-if="this.payStyle != 'f' && this.payStyle != 'p'">{{ this.reserveInfo.procName }}</span>
                            <div v-if="this.cxlFlag === 'Y'" class="mt-1">
                              <button type="button" class="rd-cxl-btn" @click="reqCxl_nbus(this.reserveInfo.reqReserveCode)" disabled>취소요청 중</button>
                            </div>
                            <div v-else class="mt-1">
                              <button type="button" class="rd-cxl-btn" @click="reqCxl_nbus(this.reserveInfo.reqReserveCode)">취소요청</button>
                            </div>
                          </div>
                        </div>
                        <div class="rd-info-row rd-info-row--col">
                          <span class="rd-info-label">담당자 안내사항</span>
                          <textarea class="rd-textarea" v-model="reserveInfo.addComment" readonly></textarea>
                        </div>
                        <div class="rd-info-row rd-info-row--col">
                          <span class="rd-info-label">예약안내사항</span>
                          <textarea class="rd-textarea" v-model="reserveInfo.supPrecaution" maxlength="5000" readonly></textarea>
                        </div>
                        <div class="rd-info-row rd-info-row--col">
                          <span class="rd-info-label">취소안내사항</span>
                          <textarea class="rd-textarea" v-model="reserveInfo.supCancellation" maxlength="5000" readonly></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 예약자 정보 (엔버스) -->
                <div class="rd-card">
                  <div class="rd-card-header">
                    <i class="bi bi-person-circle"></i>
                    <span>예약자 정보</span>
                  </div>
                  <div class="rd-card-body">
                    <div class="pc">
                      <div class="rd-info-grid">
                        <div class="rd-info-item">
                          <span class="rd-info-label">성명</span>
                          <span class="rd-info-value">{{ this.reserveInfo.inqName }}</span>
                        </div>
                        <div class="rd-info-item">
                          <span class="rd-info-label">연락처</span>
                          <span class="rd-info-value">{{ this.reserveInfo.inqTel }}</span>
                        </div>
                        <div class="rd-info-item rd-info-item--full">
                          <span class="rd-info-label">상품문의</span>
                          <textarea class="rd-textarea" v-model="reserveInfo.etcInquiry" readonly></textarea>
                        </div>
                      </div>
                    </div>
                    <div class="mobile">
                      <div class="rd-info-list">
                        <div class="rd-info-row"><span class="rd-info-label">성명</span><span class="rd-info-value">{{ this.reserveInfo.inqName }}</span></div>
                        <div class="rd-info-row"><span class="rd-info-label">연락처</span><span class="rd-info-value">{{ this.reserveInfo.inqTel }}</span></div>
                        <div class="rd-info-row rd-info-row--col">
                          <span class="rd-info-label">상품문의</span>
                          <textarea class="rd-textarea" v-model="reserveInfo.etcInquiry" readonly></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 결제 정보 (엔버스) -->
                <div class="rd-card">
                  <div class="rd-card-header">
                    <i class="bi bi-credit-card"></i>
                    <span>결제 정보</span>
                  </div>
                  <div class="rd-card-body">
                    <div class="rd-pay-summary">
                      <div class="rd-pay-row">
                        <span class="rd-pay-label">할인금액</span>
                        <span class="rd-pay-value rd-pay-value--discount">- {{ this.getCurrencyFormat(sumPrice_dc) }}원</span>
                      </div>
                      <div class="rd-pay-row rd-pay-row--total">
                        <span class="rd-pay-label">총 결제금액</span>
                        <span class="rd-pay-value rd-pay-value--total">{{ this.getCurrencyFormat(this.nbusPriceTot) }}<em>원</em></span>
                      </div>
                    </div>

                    <div class="rd-pay-history" v-if="this.paidFlag === 'Y' && totalPay <= 0">
                      <div class="rd-pay-history-item">
                        <span>결제액 ({{ this.rtnRPflag_tmp.fName }})</span>
                        <span>{{ getCurrencyFormat(this.rtnRPflag_tmp.actualPayAmount) }}원</span>
                      </div>
                    </div>
                    <div class="rd-pay-history" v-if="this.paidFlag === 'Y' && totalPay > 0">
                      <p class="rd-pay-history-title">결제 내역</p>
                      <div class="rd-pay-history-item" v-if="fPayFlag === 'N' && p1PayAmt > 0">
                        <span><i class="bi bi-stop-fill text-warning"></i> 예약금결제</span>
                        <span>{{ getCurrencyFormat(p1PayAmt) }}원 <small v-if="p1PayDate != ''">({{ p1PayDate }})</small></span>
                      </div>
                      <div class="rd-pay-history-item" v-else-if="fPayFlag === 'Y' && p1PayAmt > 0">
                        <span><i class="bi bi-stop-fill text-warning"></i> 전액결제</span>
                        <span>{{ getCurrencyFormat(p1PayAmt) }}원 <small v-if="p1PayDate != ''">({{ p1PayDate }})</small></span>
                      </div>
                      <div class="rd-pay-history-item" v-if="payPointAmt != '' && payPointAmt > 0">
                        <span><i class="bi bi-stop-fill text-success"></i> 포인트결제</span>
                        <span>{{ getCurrencyFormat(payPointAmt) }}원 <small v-if="payPointDate != ''">({{ payPointDate }})</small></span>
                      </div>
                      <div class="rd-pay-history-item" v-if="p2PayAmt != '' && p2PayAmt > 0">
                        <span><i class="bi bi-stop-fill text-danger"></i> 잔여금결제</span>
                        <span>{{ getCurrencyFormat(p2PayAmt) }}원 <small v-if="p2PayDate != ''">({{ p2PayDate }})</small></span>
                      </div>
                    </div>

                    <div class="rd-pay-btn-wrap" v-if="this.reserveInfo.inqStatus === 'RP' && this.paidFlag != 'Y'">
                      <button type="button" class="rd-pay-btn" v-if="this.reserveInfo.nbusPriceTot >= 200" @click="pgPay()">
                        <i class="bi bi-shield-check"></i> 온라인결제
                      </button>
                      <button type="button" class="rd-pay-btn rd-pay-btn--free" v-else-if="this.reserveInfo.nbusPriceTot == 0" @click="freePay(this.reqRsvCode)">
                        <i class="bi bi-gift"></i> 무료결제
                      </button>
                      <div id="payment-method" v-show="showFlag" style="height:100%"></div>
                      <button @click="requestPayment(this.reqRsvCode)" class="rd-pay-btn" id="payment-button" v-show="showFlag" style="width:100%">결제하기</button>
                    </div>

                    <div class="rd-bank-info">
                      <p class="rd-bank-title"><i class="bi bi-exclamation-triangle-fill text-danger"></i> 계좌이체 안내</p>
                      <p class="rd-bank-text">결제금액이 <b>200원 미만</b> 또는 온라인 결제가 어려운 경우 아래 계좌로 송금하실 수 있습니다.</p>
                      <p class="rd-bank-account"><i class="bi bi-bank2"></i> 우리은행 1006-901-267484 &nbsp;예금주: 엔타비글로벌</p>
                      <p class="rd-bank-sub">송금 후 <b>1660-4602</b> 또는 <b>카카오톡</b>으로 연락을 주시면 빠른 확인이 가능합니다</p>
                    </div>
                  </div>
                </div>

              </template>


              <!-- ============================
                   엔타비/엔데트 상품 섹션
              ============================= -->
              <template v-else>

                <!-- 상품 헤더 카드 -->
                <div class="rd-card rd-product-card">
                  <div class="rd-product-header">
                    <div class="rd-product-img-wrap">
                      <img v-if="this.productImage.imgName != undefined"
                        :src="`/download/${this.productId}/${this.productImage.imgName}`"
                        class="rd-product-img" alt="상품이미지">
                      <div v-else class="rd-product-img-placeholder">🗺️</div>
                    </div>
                    <div class="rd-product-meta">
                      <span class="rd-product-code">{{ this.productInfo.pdtCode }}</span>
                      <h2 class="rd-product-name">{{ this.productInfo.pdtNameKor }}</h2>
                      <div class="rd-reserve-code-wrap">
                        <span class="rd-label">예약번호</span>
                        <span class="rd-reserve-code">{{ this.reserveInfo.reqReserveCode }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 여행 일정 정보 -->
                <div class="rd-card">
                  <div class="rd-card-header">
                    <i class="bi bi-map"></i>
                    <span>여행 일정 정보</span>
                  </div>
                  <div class="rd-card-body">
                    <!-- PC -->
                    <div class="pc">
                      <div class="rd-info-grid">
                        <div class="rd-info-item">
                          <span class="rd-info-label" v-if="productInfo.salesRoute === 'F'">출발일자</span>
                          <span class="rd-info-label" v-else>여행기간</span>
                          <span class="rd-info-value" v-if="!this.reserveInfo.reqDptDate || this.reserveInfo.reqDptDate == 'Invalid date'">-</span>
                          <span class="rd-info-value" v-else-if="productInfo.salesRoute === 'F'">{{ this.reserveInfo.reqDptDate }}</span>
                          <span class="rd-info-value" v-else>{{ this.reserveInfo.reqDptDate }} ~ {{ this.reserveInfo.reqRtnDate }}</span>
                        </div>
                        <div class="rd-info-item">
                          <span class="rd-info-label" v-if="this.dTypeFlag == 'Y'">예약일</span>
                          <span class="rd-info-label" v-else>구매일</span>
                          <span class="rd-info-value">{{ this.reserveInfo.reqDate }}</span>
                        </div>
                        <div class="rd-info-item">
                          <span class="rd-info-label">여행지역</span>
                          <span class="rd-info-value">{{ this.productInfo.ntName }} / {{ this.productInfo.arName }}</span>
                        </div>
                        <div class="rd-info-item">
                          <span class="rd-info-label">
                            예약상태
                            <small v-if="this.rpCode === 'nonWP'" class="rd-account-badge">(가상계좌)</small>
                          </span>
                          <div class="rd-status-wrap">
                            <div v-if="this.rpCode === 'nonWP'">
                              <span class="rd-status-badge rd-status--request">{{ this.accPayStatus }}</span>
                            </div>
                            <div v-else>
                              <span class="rd-status-badge rd-status--paid" v-if="this.payStyle === 'f'">전액결제완료 (담당매니저 확인 중)</span>
                              <span class="rd-status-badge rd-status--partial" v-else-if="this.payStyle === 'p'">부분결제완료 (담당매니저 확인 중)</span>
                              <span class="rd-status-badge rd-status--paid" v-if="this.reserveInfo.reqStatus === 'RP' && this.paidFlag == 'Y'">결제완료 (담당매니저 확인 중)</span>
                              <span class="rd-status-badge rd-status--request" v-else-if="this.reserveInfo.reqStatus === 'RP' && this.paidFlag != 'Y'">결제요청</span>
                              <span class="rd-status-badge rd-status--paid" v-else-if="this.reserveInfo.reqStatus === 'PY' && this.reserveInfo.firstPayment == null">결제완료 (담당매니저 확인 중)</span>
                              <span class="rd-status-badge rd-status--cancel" v-else-if="this.reserveInfo.reqStatus === 'CX'"><s>{{ this.reserveInfo.procName }}</s></span>
                              <span class="rd-status-text" v-else-if="this.payStyle != 'f' && this.payStyle != 'p'">{{ this.reserveInfo.procName }}</span>
                            </div>
                            <div v-if="this.cxlFlag === 'Y'">
                              <button type="button" class="rd-cxl-btn" @click="reqCxl(this.reserveInfo.reqReserveCode, this.productId)" disabled>취소요청 중</button>
                            </div>
                            <div v-else>
                              <button type="button" class="rd-cxl-btn" @click="reqCxl(this.reserveInfo.reqReserveCode, this.productId)">취소요청</button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="rd-info-grid rd-mt">
                        <div class="rd-info-item">
                          <span class="rd-info-label">출발 → 도착</span>
                          <span class="rd-info-value" v-if="productInfo.salesRoute == 'T' || productInfo.salesRoute == 'F'">
                            한국&nbsp;{{ this.pdtTransInfo1.ddCodeName }} → &nbsp;{{ this.productInfo.ntName }}&nbsp;{{ this.pdtTransInfo1.daCodeName }}
                          </span>
                          <span class="rd-info-value" v-else-if="productInfo.salesRoute == 'L' || productInfo.salesRoute == 'E'">현지일정</span>
                          <span class="rd-info-value" v-else>-</span>
                        </div>
                        <div class="rd-info-item">
                          <span class="rd-info-label">출발편</span>
                          <span class="rd-info-value">
                            {{ this.pdtTransInfo1.dmobileCodeName }}
                            <small class="rd-flight-detail" v-if="productInfo.salesRoute == 'T' || productInfo.salesRoute == 'F'">
                              ({{ this.pdtTransInfo1.dmobileCode }}{{ this.pdtTransInfo1.dpTpCode }},&nbsp;{{ this.pdtTransInfo1.d_dpTime }} → {{ this.pdtTransInfo1.d_arTime }})
                            </small>
                          </span>
                        </div>
                        <div class="rd-info-item">
                          <span class="rd-info-label">귀국 → 도착</span>
                          <span class="rd-info-value" v-if="productInfo.salesRoute == 'T' || productInfo.salesRoute == 'F'">
                            {{ this.productInfo.ntName }}&nbsp;{{ this.pdtTransInfo1.rdCodeName }} → &nbsp;한국&nbsp;{{ this.pdtTransInfo1.raCodeName }}
                          </span>
                          <span class="rd-info-value" v-else-if="productInfo.salesRoute == 'L' || productInfo.salesRoute == 'E'">현지일정</span>
                          <span class="rd-info-value" v-else>-</span>
                        </div>
                        <div class="rd-info-item">
                          <span class="rd-info-label" v-if="productInfo.salesRoute == 'T'">귀국편</span>
                          <span class="rd-info-label" v-else>리턴편</span>
                          <span class="rd-info-value">
                            {{ this.pdtTransInfo1.rmobileCodeName }}
                            <small class="rd-flight-detail" v-if="productInfo.salesRoute == 'T' || productInfo.salesRoute == 'F'">
                              ({{ this.pdtTransInfo1.rmobileCode }}{{ this.pdtTransInfo1.rtTpcode }},&nbsp;{{ this.pdtTransInfo1.r_dpTime }} → {{ this.pdtTransInfo1.r_arTime }})
                            </small>
                          </span>
                        </div>
                      </div>

                      <!-- 신규예약 옵션 -->
                      <div v-if="this.newResFlag == 'Y'" class="rd-option-section">
                        <div class="rd-option-box">
                          <p class="rd-section-sub-title"><i class="bi bi-card-checklist"></i> 상품옵션</p>
                          <div v-if="this.selOptInfo.length <= 0" class="rd-empty-text">선택된 옵션이 없습니다.</div>
                          <div v-else>
                            <div :key="i" v-for="(so, i) in this.selOptInfo" class="rd-option-item">
                              <span class="rd-option-name">{{ so.optName }}</span>
                              <span class="rd-option-qty">{{ so.qty_opt }}개</span>
                              <span class="rd-option-price text-danger fw-bold">{{ this.getCurrencyFormat(so.optPrice * so.qty_opt) }}원</span>
                            </div>
                          </div>
                        </div>
                        <div class="rd-option-box" v-if="this.dirOptInfo.length > 0">
                          <p class="rd-section-sub-title"><i class="bi bi-pencil-square"></i> 직접입력 옵션</p>
                          <div :key="j" v-for="(dio, j) in this.dirOptInfo" class="rd-option-item">
                            <span class="rd-option-name">{{ dio.odName }}</span>
                            <span class="rd-option-price text-primary fw-bold">{{ dio.odValue }}</span>
                          </div>
                        </div>
                      </div>

                      <!-- 구형 예약 옵션 -->
                      <div v-else class="rd-option-section">
                        <div class="rd-option-box">
                          <p class="rd-section-sub-title"><i class="bi bi-card-checklist"></i> 선택옵션</p>
                          <div>{{ optName }}</div>
                        </div>
                        <div class="rd-option-box">
                          <p class="rd-section-sub-title"><i class="bi bi-bag-plus"></i> 선택추가상품</p>
                          <div v-if="this.selAddPdt.length <= 0" class="rd-empty-text">선택된 추가상품이 없습니다.</div>
                          <div v-else :key="i" v-for="(ea, i) in this.selAddPdt" class="rd-option-item">
                            <span class="rd-option-name">{{ ea.addPdtName }}</span>
                            <span class="rd-option-qty">{{ ea.qty_addPdt }}개</span>
                          </div>
                        </div>
                      </div>

                      <!-- 추가상품 (신규) -->
                      <div v-if="this.newResFlag == 'Y' && this.addPdtFlag === 'Y'" class="rd-option-section">
                        <div class="rd-option-box rd-option-box--full">
                          <p class="rd-section-sub-title"><i class="bi bi-plus-circle"></i> 추가상품</p>
                          <div v-if="this.addPdtInfo.length <= 0" class="rd-empty-text">구매하신 추가상품이 없습니다.</div>
                          <div v-else>
                            <div :key="i" v-for="(so, i) in this.addPdtInfo" class="rd-option-item">
                              <span class="rd-option-name">{{ so.addPdtName }} ▶ {{ so.addPdtValue }}</span>
                              <span class="rd-option-qty">{{ so.addQty }}개</span>
                              <span class="rd-option-price text-danger fw-bold">{{ this.getCurrencyFormat(so.addPrice * so.addQty) }}원</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- 모바일 -->
                    <div class="mobile">
                      <div class="rd-info-list">
                        <div class="rd-info-row" v-if="productInfo.salesRoute === 'F'">
                          <span class="rd-info-label">출발일자</span>
                          <span class="rd-info-value">{{ this.reserveInfo.reqDptDate }}</span>
                        </div>
                        <div class="rd-info-row" v-else>
                          <span class="rd-info-label">여행기간</span>
                          <span class="rd-info-value" v-if="!this.reserveInfo.reqDptDate || this.reserveInfo.reqDptDate == 'Invalid date'">-</span>
                          <span class="rd-info-value" v-else>{{ this.reserveInfo.reqDptDate }} ~ {{ this.reserveInfo.reqRtnDate }}</span>
                        </div>
                        <div class="rd-info-row">
                          <span class="rd-info-label">예약일</span>
                          <span class="rd-info-value">{{ this.reserveInfo.reqDate }}</span>
                        </div>
                        <div class="rd-info-row">
                          <span class="rd-info-label">여행지역</span>
                          <span class="rd-info-value">{{ this.productInfo.ntName }} / {{ this.productInfo.arName }}</span>
                        </div>
                        <div class="rd-info-row rd-info-row--col">
                          <span class="rd-info-label">
                            예약상태
                            <small v-if="this.rpCode === 'nonWP'" class="rd-account-badge">(가상계좌)</small>
                          </span>
                          <div class="rd-status-wrap">
                            <span class="rd-status-badge rd-status--paid" v-if="this.payStyle === 'f'">전액결제완료 (담당매니저 확인 중)</span>
                            <span class="rd-status-badge rd-status--partial" v-else-if="this.payStyle === 'p'">부분결제완료 (담당매니저 확인 중)</span>
                            <span class="rd-status-badge rd-status--paid" v-if="this.reserveInfo.reqStatus === 'RP' && this.paidFlag == 'Y'">결제완료 (담당매니저 확인 중)</span>
                            <span class="rd-status-badge rd-status--request" v-else-if="this.reserveInfo.reqStatus === 'RP' && this.paidFlag != 'Y'">결제요청</span>
                            <span class="rd-status-badge rd-status--paid" v-else-if="this.reserveInfo.reqStatus === 'PY' && this.reserveInfo.firstPayment == null">결제완료 (담당매니저 확인 중)</span>
                            <span class="rd-status-badge rd-status--cancel" v-else-if="this.reserveInfo.reqStatus === 'CX'"><s>{{ this.reserveInfo.procName }}</s></span>
                            <span class="rd-status-text" v-else-if="this.payStyle != 'f' && this.payStyle != 'p'">{{ this.reserveInfo.procName }}</span>
                            <div v-if="this.cxlFlag === 'Y'" class="mt-1">
                              <button type="button" class="rd-cxl-btn" @click="reqCxl(this.reserveInfo.reqReserveCode, this.productId)" disabled>취소요청 중</button>
                            </div>
                            <div v-else class="mt-1">
                              <button type="button" class="rd-cxl-btn" @click="reqCxl(this.reserveInfo.reqReserveCode, this.productId)">취소요청</button>
                            </div>
                          </div>
                        </div>
                        <div class="rd-info-row rd-info-row--col" v-if="this.newResFlag == 'Y'">
                          <span class="rd-info-label">상품옵션</span>
                          <div v-if="this.selOptInfo.length <= 0" class="rd-empty-text">선택된 옵션이 없습니다.</div>
                          <div v-else>
                            <div :key="i" v-for="(so, i) in this.selOptInfo" class="rd-option-item-mo">
                              - {{ so.optName }}&nbsp;&nbsp;({{ so.qty_opt }}개, <span class="text-danger fw-bold">{{ this.getCurrencyFormat(so.optPrice * so.qty_opt) }}</span>원)
                            </div>
                          </div>
                          <div v-if="this.dirOptInfo.length > 0">
                            <div :key="j" v-for="(dio, j) in this.dirOptInfo" class="rd-option-item-mo">
                              - {{ dio.odName }}&nbsp;&nbsp;(<span class="text-primary fw-bold">{{ dio.odValue }}</span>)
                            </div>
                          </div>
                        </div>
                        <div class="rd-info-row rd-info-row--col" v-else>
                          <span class="rd-info-label">선택옵션</span>
                          <span class="rd-info-value">{{ optName }}</span>
                        </div>
                        <div v-if="this.newResFlag == 'Y' && this.addPdtFlag === 'Y'" class="rd-info-row rd-info-row--col">
                          <span class="rd-info-label">추가상품</span>
                          <div v-if="this.addPdtInfo.length <= 0" class="rd-empty-text">구매하신 추가상품이 없습니다.</div>
                          <div v-else>
                            <div :key="i" v-for="(so, i) in this.addPdtInfo" class="rd-option-item-mo">
                              {{ so.addPdtName }} ▶ {{ so.addPdtValue }}&nbsp;&nbsp;({{ so.addQty }}개, <span class="text-danger fw-bold">{{ this.getCurrencyFormat(so.addPrice * so.addQty) }}</span>원)
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 예약자 정보 (일반) -->
                <div class="rd-card">
                  <div class="rd-card-header">
                    <i class="bi bi-person-circle"></i>
                    <span>예약자 정보</span>
                  </div>
                  <div class="rd-card-body">
                    <div class="pc">
                      <div class="rd-info-grid">
                        <div class="rd-info-item">
                          <span class="rd-info-label">이름</span>
                          <span class="rd-info-value">{{ this.reserveInfo.reqName }}</span>
                        </div>
                        <div class="rd-info-item">
                          <span class="rd-info-label">연락처</span>
                          <span class="rd-info-value">{{ this.reserveInfo.reqTelNo }}</span>
                        </div>
                        <div class="rd-info-item">
                          <span class="rd-info-label">이메일</span>
                          <span class="rd-info-value">{{ this.email }}</span>
                        </div>
                        <div class="rd-info-item">
                          <span class="rd-info-label">여행인원</span>
                          <span class="rd-info-value">{{ this.reserveInfo.reqAdultCnt*1 + this.reserveInfo.reqChildCnt*1 + this.reserveInfo.reqInfCnt*1 + this.reserveInfo.reqDiscountCnt*1 }}명</span>
                        </div>
                        <div class="rd-info-item rd-info-item--full">
                          <span class="rd-info-label">상품문의</span>
                          <textarea class="rd-textarea" v-model="reserveInfo.reqRemarks" maxlength="200" readonly></textarea>
                        </div>
                      </div>
                    </div>
                    <div class="mobile">
                      <div class="rd-info-list">
                        <div class="rd-info-row"><span class="rd-info-label">이름</span><span class="rd-info-value">{{ this.reserveInfo.reqName }}</span></div>
                        <div class="rd-info-row"><span class="rd-info-label">연락처</span><span class="rd-info-value">{{ this.reserveInfo.reqTelNo }}</span></div>
                        <div class="rd-info-row"><span class="rd-info-label">이메일</span><span class="rd-info-value">{{ this.email }}</span></div>
                        <div class="rd-info-row">
                          <span class="rd-info-label">여행인원</span>
                          <span class="rd-info-value">{{ this.reserveInfo.reqAdultCnt*1 + this.reserveInfo.reqChildCnt*1 + this.reserveInfo.reqInfCnt*1 + this.reserveInfo.reqDiscountCnt*1 }}명</span>
                        </div>
                        <div class="rd-info-row rd-info-row--col">
                          <span class="rd-info-label">상품문의</span>
                          <textarea class="rd-textarea" v-model="reserveInfo.reqRemarks" maxlength="200" readonly></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 대표 여행자 정보 -->
                <div class="rd-card" v-if="this.reserveInfo.myselfFlag === 'N'">
                  <div class="rd-card-header">
                    <i class="bi bi-people"></i>
                    <span>대표 여행자 정보</span>
                  </div>
                  <div class="rd-card-body">
                    <div class="pc">
                      <div class="rd-info-grid">
                        <div class="rd-info-item"><span class="rd-info-label">이름</span><span class="rd-info-value">{{ this.reserveInfo.tripName }}</span></div>
                        <div class="rd-info-item"><span class="rd-info-label">연락처</span><span class="rd-info-value">{{ this.reserveInfo.tripCall }}</span></div>
                        <div class="rd-info-item"><span class="rd-info-label">이메일</span><span class="rd-info-value">{{ this.reserveInfo.tripEmail }}</span></div>
                        <div class="rd-info-item">
                          <span class="rd-info-label">여행인원</span>
                          <span class="rd-info-value">{{ this.reserveInfo.reqAdultCnt*1 + this.reserveInfo.reqChildCnt*1 + this.reserveInfo.reqInfCnt*1 + this.reserveInfo.reqDiscountCnt*1 }}명</span>
                        </div>
                      </div>
                    </div>
                    <div class="mobile">
                      <div class="rd-info-list">
                        <div class="rd-info-row"><span class="rd-info-label">이름</span><span class="rd-info-value">{{ this.reserveInfo.tripName }}</span></div>
                        <div class="rd-info-row"><span class="rd-info-label">연락처</span><span class="rd-info-value">{{ this.reserveInfo.tripCall }}</span></div>
                        <div class="rd-info-row"><span class="rd-info-label">이메일</span><span class="rd-info-value">{{ this.reserveInfo.tripEmail }}</span></div>
                        <div class="rd-info-row">
                          <span class="rd-info-label">여행인원</span>
                          <span class="rd-info-value">{{ this.reserveInfo.reqAdultCnt*1 + this.reserveInfo.reqChildCnt*1 + this.reserveInfo.reqInfCnt*1 + this.reserveInfo.reqDiscountCnt*1 }}명</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 결제 정보 (일반) -->
                <div class="rd-card">
                  <div class="rd-card-header">
                    <i class="bi bi-credit-card"></i>
                    <span>결제 정보</span>
                  </div>
                  <div class="rd-card-body">
                    <div class="pc">
                      <div class="rd-pay-detail-grid">
                        <div class="rd-pay-detail-left">
                          <div v-if="this.newResFlag === 'Y'">
                            <div v-if="this.selOptInfo.length > 0">
                              <div :key="i" v-for="(so, i) in this.selOptInfo" class="rd-option-item">
                                <span class="rd-option-name">- {{ so.optName }}</span>
                                <span class="rd-option-qty">{{ so.qty_opt }}개</span>
                                <span class="rd-option-price text-danger fw-bold">{{ this.getCurrencyFormat(so.optPrice * so.qty_opt) }}원</span>
                              </div>
                            </div>
                            <div class="mt-2" v-if="this.addPdtFlag === 'Y'">
                              <div :key="i" v-for="(so, i) in this.addPdtInfo" class="rd-option-item">
                                <span class="rd-option-name">- {{ so.addPdtName }} ▶ {{ so.addPdtValue }}</span>
                                <span class="rd-option-qty">{{ so.addQty }}개</span>
                                <span class="rd-option-price text-danger fw-bold">{{ this.getCurrencyFormat(so.addPrice * so.addQty) }}원</span>
                              </div>
                            </div>
                          </div>
                          <div v-else>
                            <div class="rd-person-price">
                              <div v-if="this.reserveInfo.reqAdultCnt>0" class="rd-option-item">
                                <span class="rd-option-name">성인 {{ getCurrencyFormat(this.reserveInfo.reqAdultPrice) }}원</span>
                                <span class="rd-option-qty">× {{ this.reserveInfo.reqAdultCnt }}명</span>
                              </div>
                              <div v-if="this.reserveInfo.reqChildCnt>0" class="rd-option-item">
                                <span class="rd-option-name">소아 {{ getCurrencyFormat(this.reserveInfo.reqChildPrice) }}원</span>
                                <span class="rd-option-qty">× {{ this.reserveInfo.reqChildCnt }}명</span>
                              </div>
                              <div v-if="this.reserveInfo.reqInfCnt>0" class="rd-option-item">
                                <span class="rd-option-name">유아 {{ getCurrencyFormat(this.reserveInfo.reqInfPrice * this.reserveInfo.reqInfCnt) }}원</span>
                                <span class="rd-option-qty">× {{ this.reserveInfo.reqInfCnt }}명</span>
                              </div>
                            </div>
                            <div v-if="this.selOptions.length > 0">
                              <p class="rd-section-sub-title mt-2"><i class="bi bi-check-lg text-primary"></i> 선택옵션</p>
                              <div>{{ this.optName }} : {{ getCurrencyFormat(selOptPriceTot) }}원</div>
                            </div>
                            <div v-if="this.selAddPdt.length > 0">
                              <p class="rd-section-sub-title mt-2"><i class="bi bi-check-lg text-info"></i> 선택추가상품</p>
                              <div :key="i" v-for="(ea, i) in this.selAddPdt" class="rd-option-item">
                                <span class="rd-option-name">{{ ea.addPdtName }}</span>
                                <span class="rd-option-qty">{{ ea.qty_addPdt }}개</span>
                                <span class="rd-option-price text-info fw-bold">{{ this.getCurrencyFormat(ea.aduPdtPrice * ea.qty_addPdt) }}원</span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="rd-pay-detail-right">
                          <div class="rd-pay-summary">
                            <div class="rd-pay-row rd-pay-row--total">
                              <span class="rd-pay-label">총 결제금액</span>
                              <span class="rd-pay-value rd-pay-value--total">{{ this.getCurrencyFormat(this.reserveInfo.cstPrice_new) }}<em>원</em></span>
                            </div>
                          </div>

                          <div class="rd-pay-history" v-if="this.paidFlag === 'Y' && totalPay <= 0">
                            <div class="rd-pay-history-item">
                              <span>결제액 ({{ this.rtnRPflag_tmp.fName }})</span>
                              <span>{{ getCurrencyFormat(this.rtnRPflag_tmp.actualPayAmount) }}원</span>
                            </div>
                          </div>
                          <div class="rd-pay-history" v-if="this.paidFlag === 'Y' && totalPay > 0">
                            <p class="rd-pay-history-title">결제 내역</p>
                            <div class="rd-pay-history-item" v-if="fPayFlag === 'N' && p1PayAmt > 0">
                              <span><i class="bi bi-stop-fill text-warning"></i> 예약금결제</span>
                              <span>{{ getCurrencyFormat(p1PayAmt) }}원 <small v-if="p1PayDate != ''">({{ p1PayDate }})</small></span>
                            </div>
                            <div class="rd-pay-history-item" v-else-if="fPayFlag === 'Y' && p1PayAmt > 0">
                              <span><i class="bi bi-stop-fill text-warning"></i> 전액결제</span>
                              <span>{{ getCurrencyFormat(p1PayAmt) }}원 <small v-if="p1PayDate != ''">({{ p1PayDate }})</small></span>
                            </div>
                            <div class="rd-pay-history-item" v-if="payPointAmt != '' && payPointAmt > 0">
                              <span><i class="bi bi-stop-fill text-success"></i> 포인트결제</span>
                              <span>{{ getCurrencyFormat(payPointAmt) }}원 <small v-if="payPointDate != ''">({{ payPointDate }})</small></span>
                            </div>
                            <div class="rd-pay-history-item" v-if="p2PayAmt != '' && p2PayAmt > 0">
                              <span><i class="bi bi-stop-fill text-danger"></i> 잔여금결제</span>
                              <span>{{ getCurrencyFormat(p2PayAmt) }}원 <small v-if="p2PayDate != ''">({{ p2PayDate }})</small></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- 모바일 결제 -->
                    <div class="mobile">
                      <div class="rd-pay-summary">
                        <div class="rd-pay-row rd-pay-row--total">
                          <span class="rd-pay-label">총 결제금액</span>
                          <span class="rd-pay-value rd-pay-value--total">{{ this.getCurrencyFormat(this.reserveInfo.cstPrice_new) }}<em>원</em></span>
                        </div>
                      </div>
                      <div class="rd-pay-history" v-if="this.paidFlag === 'Y' && totalPay <= 0">
                        <div class="rd-pay-history-item">
                          <span>결제액 ({{ this.rtnRPflag_tmp.fName }})</span>
                          <span>{{ getCurrencyFormat(this.rtnRPflag_tmp.actualPayAmount) }}원</span>
                        </div>
                      </div>
                      <div class="rd-pay-history" v-if="this.paidFlag === 'Y' && totalPay > 0">
                        <p class="rd-pay-history-title">결제 내역</p>
                        <div class="rd-pay-history-item" v-if="fPayFlag === 'N' && p1PayAmt > 0">
                          <span><i class="bi bi-stop-fill text-warning"></i> 예약금결제</span>
                          <span>{{ getCurrencyFormat(p1PayAmt) }}원<br><small v-if="p1PayDate != ''">({{ p1PayDate }})</small></span>
                        </div>
                        <div class="rd-pay-history-item" v-else-if="fPayFlag === 'Y' && p1PayAmt > 0">
                          <span><i class="bi bi-stop-fill text-warning"></i> 전액결제</span>
                          <span>{{ getCurrencyFormat(p1PayAmt) }}원<br><small v-if="p1PayDate != ''">({{ p1PayDate }})</small></span>
                        </div>
                        <div class="rd-pay-history-item" v-if="payPointAmt != '' && payPointAmt > 0">
                          <span><i class="bi bi-stop-fill text-success"></i> 포인트결제</span>
                          <span>{{ getCurrencyFormat(payPointAmt) }}원<br><small v-if="payPointDate != ''">({{ payPointDate }})</small></span>
                        </div>
                        <div class="rd-pay-history-item" v-if="p2PayAmt != '' && p2PayAmt > 0">
                          <span><i class="bi bi-stop-fill text-danger"></i> 잔여금결제</span>
                          <span>{{ getCurrencyFormat(p2PayAmt) }}원<br><small v-if="p2PayDate != ''">({{ p2PayDate }})</small></span>
                        </div>
                      </div>
                    </div>

                    <!-- 결제 버튼 -->
                    <div class="rd-pay-btn-wrap" v-if="this.reserveInfo.reqStatus === 'RP' && this.paidFlag != 'Y'">
                      <button type="button" class="rd-pay-btn" v-if="this.reserveInfo.cstPrice_new >= 200" @click="pgPay()">
                        <i class="bi bi-shield-check"></i> 온라인결제
                      </button>
                      <button type="button" class="rd-pay-btn rd-pay-btn--free" v-else-if="this.reserveInfo.cstPrice_new == 0" @click="freePay(this.reqRsvCode)">
                        <i class="bi bi-gift"></i> 무료결제
                      </button>
                      <div id="payment-method" v-show="showFlag" style="height:100%"></div>
                      <button @click="requestPayment(this.reqRsvCode)" class="rd-pay-btn" id="payment-button" v-show="showFlag" style="width:100%">결제하기</button>
                    </div>

                    <!-- 잔액결제 버튼 -->
                    <div class="rd-pay-btn-wrap" v-if="this.rtnRPflag_tmp.reqPayBalance === 'Y'">
                      <button type="button" class="rd-pay-btn rd-pay-btn--balance" v-if="this.balance >= 200" @click="pgPay('p2')">
                        <i class="bi bi-shield-check"></i> 온라인 잔액결제 ({{ this.getCurrencyFormat(this.balance) }}원)
                      </button>
                      <button type="button" class="rd-pay-btn rd-pay-btn--free" v-else-if="this.reserveInfo.cstPrice_new == 0" @click="freePay(this.reqRsvCode, 'p2')">
                        <i class="bi bi-gift"></i> 무료잔액결제
                      </button>
                      <div id="payment-method" v-show="showFlag" style="height:100%"></div>
                      <button @click="requestPayment(this.reqRsvCode, 'p2')" class="rd-pay-btn" id="payment-button" v-show="showFlag" style="width:100%">잔액결제</button>
                    </div>

                    <div class="rd-bank-info">
                      <p class="rd-bank-title"><i class="bi bi-exclamation-triangle-fill text-danger"></i> 계좌이체 안내</p>
                      <p class="rd-bank-text">결제금액이 <b>200원 미만</b> 또는 온라인 결제가 어려운 경우 아래 계좌로 송금하실 수 있습니다.</p>
                      <p class="rd-bank-account"><i class="bi bi-bank2"></i> 우리은행 1006-901-267484 &nbsp;예금주: 엔타비글로벌</p>
                      <p class="rd-bank-sub">송금 후 <b>1660-4602</b> 또는 <b>카카오톡</b>으로 연락을 주시면 빠른 확인이 가능합니다</p>
                    </div>
                  </div>
                </div>

              </template>

            </div>
          </div>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
import { loadPaymentWidget, ANONYMOUS } from "@tosspayments/payment-widget-sdk";
import axios from 'axios';
import { handlerInfo } from '../assets/js/commonFunctions'

export default {
  data() {
    return {
      showFlag: false,
      paymentWidget: null,
      paymentMethodWidget: null,
      //clientKey: "test_ck_YyZqmkKeP8gG2Klanln8bQRxB9lG",
      clientKey: "live_ck_jZ61JOxRQVEZXa1aoR0rW0X9bAqw",
      customerKey: "Ntabi-1936=@",
      loginInfo_E: [],
      productInfo: [],
      reserveInfo: [],
      selOptInfo: [],
      dirOptInfo: [],
      newResFlag: "",
      isReviewFlag: "",
      aPromoFlag: "N",
      selEctOptList: [],
      productCode: "",
      email: "",
      payPointAmt: 0,
      availPoint: 0,
      paidPoint: 0,
      payPointFlag: "N",
      pointForPay: 0,
      payByPointFlag: "N",
      pointForPay_tmp: 0,
      rtnRPflag_tmp: [],
      rtnRPflag: "N",
      paidFlag: "N",
      tot_checkedOptPrice: 0,
      productTrans: [],
      pdtTransInfo1: [],
      pdtTransInfo: [],
      pdtPromoInfo: [],
      pdtFlag: "",
      productImage: [],
      selectedProcCode: "",
      sRoute: [],
      reqMarginRate: 0,
      reqMarginMethod: "P",
      productPromotion: [],
      choicePromotion: [],
      promoList: [],
      optFlag: "",
      pdtcode: "",
      productPrice: [],
      promoStart: "",
      promoEnd: "",
      cxlFlag: "N",
      selOptFlag: "N",
      selAddFlag: "N",
      pdtOptInfo: [],
      pdtOptFlag: "N",
      calOptFlag: "N",
      selOptions: [],
      tot_selOptPrice: 0,
      selOptNames: [],
      calAddFlag: "N",
      selAddPdt: [],
      tot_selAddPdtPrice: 0,
      selAddPdtNames: [],
      balance: 0,
      payStyle: "",
      userPayInfo: [],
      p1PayAmt: 0,
      p1PayDate: "",
      p2PayAmt: 0,
      p2PayDate: "",
      payPointDate: "",
      fPayFlag: "",
      totalPay: 0,
      optName: "",
      selOptPriceTot: [],
      paymentInFull: "N",
      virAccInfo: [],
      accPayStatus: "",
      nbusInfo: [],
      exist_nbRoute: [],
      sumPrice_dc: 0,
      nbusPriceTot: 0,
      handTel: [],
      handTelCnt: 0,
      addPdtFlag: "N",
      addPdtInfo: [],
      // 호텔 예약
      bookingNo:          '',
      hotelBookingInfo:   {},
      hotelBookingGuests: [],
      hotelDetailInfo:    {},
      hotelCancelLoading: false,
    };
  },

  computed: {
    user() { return this.$store.state.user; },
    total_amount() { return this.$store.state.total_amount; },

    cancelPolicyDetails() {
      const raw = this.hotelBookingInfo.cancel_policy
      if (!raw) return []
      let policy
      try { policy = typeof raw === 'string' ? JSON.parse(raw) : raw }
      catch (e) { return [] }
      const policies = policy.cancellation_policies || []
      if (policies.length === 0) return []
      const now = new Date()
      return policies.map(p => {
        const from    = p.date_from ? new Date(p.date_from) : null
        const to      = p.date_to   ? new Date(p.date_to)   : null
        const percent = p.penalty_percentage || 0
        let percentText = '', percentColor = '#16a34a'
        if      (percent === 0)  { percentText = '무료취소';        percentColor = '#16a34a' }
        else if (percent >= 100) { percentText = '환불불가 (100%)'; percentColor = '#c62828' }
        else                     { percentText = `${percent}% 수수료`;     percentColor = '#b45309' }
        const isCurrent = !!(from && now >= from && (!to || now < to))
        return {
          label: `${from ? this.getKorDateFormat(from) : '-'} ~ ${to ? this.getKorDateFormat(to) : '-'}`,
          percentText, percentColor, isCurrent
        }
      })
    },
  },

  created() {
    this.reqRsvCode = this.$route.query.seqReq;
    this.productId  = this.$route.query.pCode  || ""
    this.copyFlag   = this.$route.query.cCode  || ""
    this.rpCode     = this.$route.query.rpCode || ""
    // this.ctCode     = this.$route.query.ctCode || ""   // 'H' or 'nbus' or ''
    this.ctCode = this.$route.query.cCode ? this.$route.query.cCode : this.$route.query.ctCode;                 //N:엔버스 H:호텔  Y:상품

    // 호텔 예약
    if (this.ctCode === 'H') {
      this.bookingNo = this.$route.query.bookingNo || ""
      return
    }
  },

  async mounted() {
    if (this.rpCode === 'nonRP' || this.rpCode === 'nonCO' || this.rpCode === 'nonWP' || this.ctCode === 'nbus') {
      this.checkNonMem(this.reqRsvCode, this.rpCode, this.ctCode)
    }
    if (this.ctCode === 'H') {
      this.checkNonMem_hotel()
    }
  },

  methods: {
    getDateFormat(date)    { return this.$dateFormat(date); },

    // ── 호텔 구글맵 ──────────────────────────────────────────
    loadGoogleMaps_hotel() {
      if (window.google?.maps) { this.initMap_hotel(); return }
      const script = document.createElement('script')
      script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.VUE_APP_GOOGLE_API_KEY}&language=ko`
      script.async = true; script.defer = true
      script.onload = () => this.initMap_hotel()
      document.head.appendChild(script)
    },

    initMap_hotel() {
      if (!this.hotelDetailInfo.latitude || !this.hotelDetailInfo.longitude) return
      const lat = parseFloat(this.hotelDetailInfo.latitude)
      const lng = parseFloat(this.hotelDetailInfo.longitude)
      const mapEl = document.getElementById('hotel-detail-map')
      if (!mapEl) return
      const map = new window.google.maps.Map(mapEl, { center: { lat, lng }, zoom: 15, mapTypeControl: false, streetViewControl: false, fullscreenControl: true })
      new window.google.maps.Marker({ position: { lat, lng }, map, title: this.hotelBookingInfo.hotel_name, icon: { url: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png' } })
      new window.google.maps.InfoWindow({ content: `<div style="font-size:13px; font-weight:700; padding:4px 8px;">${this.hotelBookingInfo.hotel_name}</div>` }).open(map)
    },

    // ── 호텔 예약 상세 조회 ──────────────────────────────────
    async getHotelBookingDetail() {
      const info = await this.$api('/api/hotelBookingDetail', { param: [this.bookingNo] })
      if (info && info.length > 0) {
        this.hotelBookingInfo = info[0]
        const detail = await this.$api('/api/hotelDetailForBooking', { param: [this.hotelBookingInfo.hotel_id] })
        if (detail && detail.length > 0) {
          this.hotelDetailInfo = detail[0]
          this.$nextTick(() => this.loadGoogleMaps_hotel())
        }
      }
      const guests = await this.$api('/api/hotelBookingGuests', { param: [this.bookingNo] })
      if (guests && guests.length > 0) this.hotelBookingGuests = guests
    },

    hotelStatusText(status) {
      const map = { 'bkg-ip': '처리중', 'bkg-ps': '확인중', 'bkg-cf': '예약확정', 'bkg-cx': '취소', 'bkg-af': '예약실패' }
      return map[status] || status
    },

    hotelStatusClass(status) {
      const map = { 'bkg-ip': 'status-h-wait', 'bkg-ps': 'status-h-wait', 'bkg-cf': 'status-h-done', 'bkg-cx': 'status-h-cancel', 'bkg-af': 'status-h-danger' }
      return map[status] || ''
    },

    // ── 호텔 취소 ① 진입점 ──────────────────────────────────
    async reqCancelHotel() {
      this.hotelCancelLoading = true

      // 취소 수수료 조회
      let chargeInfo = null
      try 
      {
        const res = await axios.post('/api/hotel/getCancelCharge', { bookingNo: this.bookingNo })
        chargeInfo = res.data
      } 
      catch (e) 
      {
        console.error('[getCancelCharge]', e)
        this.hotelCancelLoading = false
        this.reqCxlHotelRequestOnly()
        return
      }
      this.hotelCancelLoading = false

      const chargeKrw = chargeInfo?.chargeKrw || 0
      const totalKrw  = this.hotelBookingInfo.selling_krw || 0
      const refundKrw = totalKrw - chargeKrw

      if (chargeKrw === 0) {
        const result = await this.$swal.fire({
          title: '예약 취소',
          html: `<div class="text-start" style="font-size:.88rem;"><p>✅ 취소 수수료가 없습니다. <b>전액 환불</b>됩니다.</p><hr><table style="width:100%; border-collapse:collapse;"><tr><td>결제금액</td><td class="text-end fw-bold">${this.getCurrencyFormat(totalKrw)}원</td></tr><tr><td>취소 수수료</td><td class="text-end" style="color:#16a34a; font-weight:700;">없음</td></tr><tr style="border-top:1px solid #e2e8f0;"><td class="fw-bold">환불 예정금액</td><td class="text-end fw-bold" style="color:#1565c0;">${this.getCurrencyFormat(refundKrw)}원</td></tr></table><p class="text-muted mt-2" style="font-size:.76rem;">취소환불일정은 결제수단에 따라 상이할 수 있습니다.</p></div>`,
          showCancelButton: true, confirmButtonText: '취소 진행', cancelButtonText: '돌아가기', confirmButtonColor: '#c62828',
        })
        if (result.isConfirmed) { await this.$nextTick(); this.processCancelHotel(0) }
      } else {
        const result = await this.$swal.fire({
          title: '⚠️ 취소 수수료 발생',
          html: `<div class="text-start" style="font-size:.88rem;"><p class="fw-bold" style="color:#c62828;">현재 취소 시 수수료가 발생합니다.</p><hr><table style="width:100%; border-collapse:collapse;"><tr><td>결제금액</td><td class="text-end">${this.getCurrencyFormat(totalKrw)}원</td></tr><tr><td>취소 수수료</td><td class="text-end fw-bold" style="color:#c62828;">- ${this.getCurrencyFormat(chargeKrw)}원</td></tr><tr style="border-top:1px solid #e2e8f0;"><td class="fw-bold">환불 예정금액</td><td class="text-end fw-bold" style="color:#1565c0;">${this.getCurrencyFormat(refundKrw)}원</td></tr></table><div style="background:#fffbeb; border:1px solid #fde68a; border-radius:8px; padding:.75rem; margin-top:.8rem; font-size:.76rem; color:#78350f;">📋 ${this.hotelBookingInfo.cancel_remarks}</div></div>`,
          showCancelButton: true, confirmButtonText: '취소 진행', cancelButtonText: '돌아가기', confirmButtonColor: '#c62828',
        })
        if (result.isConfirmed) { await this.$nextTick(); this.processCancelHotel(chargeKrw) }
      }
    },

    // ── 호텔 취소 ② 실행 ────────────────────────────────────
    async processCancelHotel(cancelFee) {
      this.$swal.fire({ title: '취소 처리 중...', html: '잠시만 기다려 주세요.', allowOutsideClick: false, showConfirmButton: false, didOpen: () => this.$swal.showLoading() })
      try {
        const res = await axios.post('/api/hotel/cancelBooking', {
          bookingNo: this.bookingNo,
          cancelFee,
          cxlId: this.hotelBookingInfo.contact_email || this.hotelBookingInfo.contact_no || 'nonmember',
        })
        this.$swal.close()
        if (res.data.success) 
        {
          // ✅ 환불금액 계산 (selling_krw - cancelFee)
          let refundAmt = (this.hotelBookingInfo.selling_krw || 0) - cancelFee
          // ✅ 취소 알림톡 발송 (발송 실패해도 취소 처리에 영향 없음)
          this.sendKakaoHotelCancel(cancelFee, refundAmt)

          await this.$swal.fire('취소 완료', '예약이 취소되었으며 환불이 처리됩니다.<br>환불일정은 결제수단에 따라 상이할 수 있습니다.', 'success')
          this.hotelBookingInfo.status = 'bkg-cx'
        } 
        else 
        {
          this.$swal.fire('오류', res.data.message || '취소 처리 중 오류가 발생했습니다.<br>고객센터(1660-4602)로 문의해주세요.', 'error')
        }
      } 
      catch (e) 
      {
        this.$swal.close()
        console.error('[processCancelHotel]', e)
        this.$swal.fire('오류', '취소 처리 중 오류가 발생했습니다.<br>고객센터(1660-4602)로 문의해주세요.', 'error')
      }
    },

    // ── 호텔 취소 알림톡 발송(취소확정 CX) ──────────────────────────────────────
    sendKakaoHotelCancel(cancelFee = 0, refundAmt = 0) {
      const sendTargets = []
      this.handTel.forEach(h => {
        sendTargets.push({ callNo: h.aimCall, callName: h.handlerName ?? '담당자' })
      })
      sendTargets.push({
        callNo  : this.hotelBookingInfo.contact_no   || '',
        callName: this.hotelBookingInfo.contact_name || ''
      })

      let stayDateRange = `${this.getDateFormat(this.hotelBookingInfo.check_in)} ~ ${this.getDateFormat(this.hotelBookingInfo.check_out)}`
      let paxCnt        = `대인: ${this.hotelBookingInfo.adult_count || 0} / 소인: 0`
      let today         = new Date().toISOString().slice(0, 10)   // 취소일자 YYYY-MM-DD

      const promises = sendTargets.map(target => {
        const kakaoAlimData = {
          alimFlag    : 'CX',
          clientCall  : target.callNo,
          clientName  : target.callName,
          rtxName     : this.hotelBookingInfo.hotel_name,                  // PY와 동일 키
          resName     : this.hotelBookingInfo.hotel_name,                  // CX 템플릿용
          resPaxName  : this.hotelBookingInfo.contact_name,
          resPaxCnt   : paxCnt,
          resRoom     : this.hotelBookingInfo.room_count,
          resStayDate : stayDateRange,                                     // PY와 동일 키
          resPhone    : this.hotelBookingInfo.contact_no,
          resCode     : this.bookingNo,
          resDate     : today,                                             // 취소일자
          resPayAmount: this.getCurrencyFormat(refundAmt) + '원',          // 환불금액
          resFeeAmount: this.getCurrencyFormat(cancelFee) + '원',          // 취소수수료
          memFlag     : this.hotelBookingInfo.mem_flag || 'N',
        }
        return this.$api('api/kakaoAlimSend10', { param: [{ kakaoAlimData }] })
          .catch(e => console.error('[호텔 취소 알림톡 실패]', target.callNo, e))
      })
      Promise.all(promises)
    },

    // ── 호텔 취소 ③ 요청만 (정책 없는 경우) ─────────────────
    async reqCxlHotelRequestOnly() {
      const result = await this.$swal.fire({
        title: '예약 취소 요청',
        html: '<div class="text-start" style="font-size:.88rem;"><p>취소 정책 확인이 필요합니다.</p><p class="text-muted">취소 요청 접수 후 담당자가 확인하여 처리해드립니다.</p></div>',
        showCancelButton: true, confirmButtonText: '취소 요청', cancelButtonText: '돌아가기', confirmButtonColor: '#b45309',
      })
      if (!result.isConfirmed) return
      try {
        const res = await this.$api('/api/insReqCxlReserve', { param: [this.bookingNo, this.hotelBookingInfo.contact_email || 'nonmember', 'Y'] })
        if (res.affectedRows > 0) {
          await this.$swal.fire('', '취소 요청이 접수되었습니다.<br>담당자가 확인 후 연락드립니다.', 'success')
          this.hotelBookingInfo.status = 'bkg-cx'
        } else {
          this.$swal.fire('오류', '요청 처리 중 오류가 발생했습니다.<br>고객센터(1660-4602)로 문의해주세요.', 'error')
        }
      } catch (e) {
        console.error('[reqCxlHotelRequestOnly]', e)
        this.$swal.fire('오류', '요청 처리 중 오류가 발생했습니다.', 'error')
      }
    },
    getCurrencyFormat(val) { return this.$currencyFormat(val); },
    getKorDateFormat(date) { return this.$korDateFormat(date); },
    getTruncateToWon(val)  { return this.$truncateToWon(val); },

    async checkNonMem(rCode, rpCode, ctCode) {
      const { value: formValues } = await this.$swal.fire({
        html:
          '<div class="searchNonRes">' +
          '<b class="text-danger">비회원예약</b> <b>확인</b><br>' +
          '<input id="nResName" class="swal2-input" placeholder="예약자성명" style="font-size:1.0rem;">' +
          '<input id="nResCall" class="swal2-input" placeholder="예약자연락처(01012345678)" style="font-size:1.0rem;">' +
          '<label id="nResCode" class="swal2-input" style="background:darkgray; font-size:1.0rem; color:white; padding-top:6px; vertical-align:middle; width:210px;" placeholder="예약번호">' + rCode + '</label>' +
          '</div>',
        confirmButtonText: "확인",
        showCancelButton: true,
        cancelButtonText: "취소",
        imageUrl: '/IMGs/payment.png',
        imageWidth: 400,
        imageHeight: 200,
        focusConfirm: false,
        preConfirm: () => [
          document.getElementById('nResName').value,
          document.getElementById('nResCall').value,
        ]
      })

      if (!formValues) { location.reload(true); return; }

      let nResName = formValues[0]
      let nResCall = formValues[1]
      let loginInfo_E = []

      if (ctCode === "nbus") 
      {
        loginInfo_E = await this.$api("/api/checkResNbus", { param: [nResName, nResCall, rCode] });
      } 
      else 
      {
        loginInfo_E = await this.$api("/api/checkResNonMember", { param: [nResName, nResCall, rCode] });
      }

      if (loginInfo_E.length > 0) {
        this.loginInfo_E = loginInfo_E[0]
        this.$swal.fire("", '<b>' + loginInfo_E[0].reqName + '님</b>, 반갑습니다(비회원예약)', "success")
        this.getReserInfo();
        if (this.ctCode == "") {
          this.getProductInfo();
          this.getProductImage();
          this.getPdtPromotion_apply();
          this.getProductPromotion();
        }
        this.getReqProcLevel();
        this.getHandlerInfo();
      } else {
        this.$swal.fire("", "카카오알림톡으로 안내된 정보를 확인해주세요<br>확인이 어려운 경우 문의처: <b class='text-danger'>1660-4062</b>", "warning")
        location.reload(true)
      }
    },

    // ── 호텔 비회원 확인 ──────────────────────────────────────────
    async checkNonMem_hotel() {
      const { value: formValues } = await this.$swal.fire({
        html:
          '<div class="searchNonRes">' +
          '<b class="text-danger">비회원 호텔예약</b> <b>확인</b><br>' +
          '<input id="nResEmail" class="swal2-input" placeholder="예약 시 입력한 이메일" type="email" style="font-size:1.0rem;">' +
          '<input id="nResCall"  class="swal2-input" placeholder="예약자연락처(01012345678)" style="font-size:1.0rem;">' +
          '<label class="swal2-input" style="background:darkgray; font-size:1.0rem; color:white; padding-top:6px; vertical-align:middle; width:210px;">' +
          this.bookingNo +
          '</label>' +
          '</div>',
        confirmButtonText: '확인',
        showCancelButton:  true,
        cancelButtonText:  '취소',
        imageUrl:    '/IMGs/payment.png',
        imageWidth:  400,
        imageHeight: 200,
        focusConfirm: false,
        preConfirm: () => [
          document.getElementById('nResEmail').value,
          document.getElementById('nResCall').value,
        ]
      })

      if (!formValues) { location.reload(true); return; }

      const [email, phone] = formValues

      const result = await this.$api('/api/checkResNonMember_hotel', {
        param: [this.bookingNo, email, phone]
      })

      if (result && result.length > 0) {
        this.$swal.fire('', `<b>${result[0].contact_name}님</b>, 반갑습니다 (비회원 호텔예약)`, 'success')
        await this.getHotelBookingDetail()
        await this.getHandlerInfo()
      } else {
        this.$swal.fire(
          '',
          '예약 정보가 확인되지 않습니다.<br>예약 시 입력한 이메일과 연락처를 확인해주세요.<br>문의처: <b class="text-danger">1660-4602</b>',
          'warning'
        )
        location.reload(true)
      }
    },


    async getNbusPrice(nbCode) {
      let nbusPriceSum = await this.$api("/api/nbusPriceSum", { param: [nbCode, "M", "Y"] })
      if (nbusPriceSum.length > 0) {
        this.sumPrice_dc = (nbusPriceSum[0].sumPrice < 0 || nbusPriceSum[0].sumPrice == null) ? 0 : nbusPriceSum[0].sumPrice
      }
      let nbusPriceTot = await this.$api("/api/resNbusPrice", { param: [nbCode, "Y"] })
      this.nbusPriceTot = (nbusPriceTot[0].result === undefined || !nbusPriceTot[0].result) ? 0 : nbusPriceTot[0].result
    },

    async getReserInfo() {
      let reserveInfo = []
      let exist_nbRoute = []

      if (this.ctCode === "nbus") {
        reserveInfo = await this.$api("/api/reqResConsultDetail_nbus", { param: [this.reqRsvCode] });
        exist_nbRoute = await this.$api("/api/nbusInqInfo_d", { param: [this.reqRsvCode] });
        if (reserveInfo.length > 0) {
          this.reserveInfo = reserveInfo[0]
          this.reserveInfo.rentStartDate = this.getDateFormat(this.reserveInfo.rentStartDate);
          this.reserveInfo.insDate = this.getDateFormat(this.reserveInfo.insDate);
        }
        if (exist_nbRoute.length > 0) this.exist_nbRoute = exist_nbRoute
      } else {
        reserveInfo = await this.$api("/api/resConsultDetail_new", { param: [this.reqRsvCode] });
        this.newResFlag = (reserveInfo.length > 0) ? reserveInfo[0].newResFlag : "N";
        if (reserveInfo.length > 0) {
          if (this.newResFlag === "Y") {
            this.reserveInfo = reserveInfo[0];
            this.tot_perCount = reserveInfo[0].totalCount
            this.productCode = reserveInfo[0].reqPdtCode;
            this.reserveInfo.reqDptDate = this.getDateFormat(this.reserveInfo.reqDptDate);
            this.reserveInfo.reqRtnDate = this.getDateFormat(this.reserveInfo.reqRtnDate);
            this.reserveInfo.reqDate = this.getDateFormat(this.reserveInfo.reqDate);
            if (reserveInfo[0].addPdtFlag === "Y") {
              this.addPdtFlag = "Y"
              let addPdtInfo = await this.$api("/api/addPdtInfo", { param: [this.reqRsvCode] })
              if (addPdtInfo.length > 0) this.addPdtInfo = addPdtInfo
            }
          } else {
            reserveInfo = []
            reserveInfo = await this.$api("/api/resConsultDetail", { param: [this.reqRsvCode] });
            if (reserveInfo.length > 0) {
              this.reserveInfo = reserveInfo[0];
              this.productCode = reserveInfo[0].reqPdtCode;
              this.reserveInfo.optDcPrice = (this.reserveInfo.optDcPrice == null) ? 0 : this.reserveInfo.optDcPrice
              this.email = (this.reserveInfo.conEmail == undefined || this.reserveInfo.conEmail == null) ? this.reserveInfo.reqEmail : this.reserveInfo.conEmail
              this.reserveInfo.reqDptDate = this.getDateFormat(this.reserveInfo.reqDptDate);
              this.reserveInfo.reqRtnDate = this.getDateFormat(this.reserveInfo.reqRtnDate);
              this.reserveInfo.reqDate = this.getDateFormat(this.reserveInfo.reqDate);
              this.pdtFlag = (this.productId.substring(0, 2) === 'MX') ? "MX" : "SG"
              this.reqMarginRate = (this.reserveInfo.reqMarginRate == null) ? this.productInfo.basicMargin : this.reserveInfo.reqMarginRate;
              this.reqMarginMethod = (this.reserveInfo.reqMarginMethod == null) ? this.productInfo.marginMethod : this.reserveInfo.reqMarginMethod;
            }
          }
        }
      }

      if (this.ctCode == "") {
        if (this.newResFlag === "Y") {
          this.getSelOptInfo();
          this.getDirOptInfo();
        } else {
          this.getSelOptions_new(this.reqRsvCode)
          this.getSelAddProductions(this.reqRsvCode)
        }
      }
      if (this.ctCode === "nbus") this.getNbusPrice(this.reqRsvCode)
      this.getReqPayInfo(this.reqRsvCode);
      this.getResCxlCheck(this.reqRsvCode)
    },

    async getSelOptInfo() {
      let selOptInfo = await this.$api("/api/selOptInfo", { param: [this.reqRsvCode] });
      if (selOptInfo.length > 0) { this.selOptFlag = "Y"; this.selOptInfo = selOptInfo; this.getTotalPrice(); }
      else this.getTotalPrice();
    },

    async getDirOptInfo() {
      let dirOptInfo = await this.$api("/api/dirOptInfo", { param: [this.reqRsvCode] });
      if (dirOptInfo.length > 0) { this.dirOptFlag = "Y"; this.dirOptInfo = dirOptInfo; }
    },

    getTotalPrice() {
      this.pdtTotalPrice = this.selOptInfo.length > 0
        ? this.selOptInfo.reduce((sum, item) => sum + (item.optPrice * (item.qty_opt ?? 0)), 0) : 0
    },

    async getSelOptions_new(resCode) {
      let selOptions = await this.$api("/api/getSelOptions_new", { param: [resCode, "Y"] });
      if (selOptions.length > 0) {
        this.selOptions = selOptions; this.selOptFlag = "Y";
        this.optName = selOptions[0].optPdtName
        this.selOptPriceTot = (selOptions[0].optPrice * selOptions[0].cntAdu) + (selOptions[0].optPrice_chi * selOptions[0].cntChi) + (selOptions[0].optPrice_inf * selOptions[0].cntInf)
      } else { this.selOptFlag = "N"; this.optName = "선택된 옵션이 없습니다" }
    },

    async getSelAddProductions(resCode) {
      let selAddPdt = await this.$api("/api/getSelAddProductions", { param: [resCode, "Y"] });
      if (selAddPdt.length > 0) {
        this.selAddPdt = selAddPdt; this.selAddFlag = "Y";
        selAddPdt.forEach(sa => { this.tot_selAddPdtPrice += (sa.addPdtPrice * sa.qty_addPdt); this.selAddPdtNames.push(sa.addPdtName); });
      } else { this.selAddFlag = "N"; this.selAddPdtNames = "없음" }
    },

    async getProductInfo() {
      let productInfo = await this.$api("/api/productDetail_new", { param: [this.productId] });
      if (productInfo.length > 0) this.productInfo = productInfo[0]
      this.getProductTransInfoExited();
    },

    async getProductImage() {
      let productImage = await this.$api("/api/productImage_new", { param: [this.productId, 'T'] });
      if (productImage.length > 0) this.productImage = productImage[0]
    },

    async getResCxlCheck(rCode) {
      let cxlStatus = await this.$api("/api/checkReqCxl", { param: [rCode] });
      if (cxlStatus.length > 0) this.cxlFlag = "Y"
    },

    async getPdtPromotion() {
      let pdtPromoInfo = await this.$api("/api/pdtPromo_existed", { param: [this.productId] });
      if (pdtPromoInfo.length > 0) {
        this.pdtPromoInfo = pdtPromoInfo[0];
        if (this.pdtPromoInfo.promoStart) this.pdtPromoInfo.promoStart = this.getDateFormat(this.pdtPromoInfo.promoStart);
        if (this.pdtPromoInfo.promoEnd) this.pdtPromoInfo.promoEnd = this.getDateFormat(this.pdtPromoInfo.promoEnd);
      }
    },

    async reqCxl(rCode, pCode) {
      let res_supCxl = await this.$api("/api/supCxl", { param: pCode })
      let supCxl = res_supCxl.length > 0 ? res_supCxl[0] : { supCancellation: "" }
      this.$swal.fire({
        html: "예약취소를 요청하시겠습니까?<br><br><p class='text-start swal-popup'>" + supCxl.supCancellation.split('\n').join('<br>') + "</p>",
        showCancelButton: true, confirmButtonText: '동의하고 요청합니다', cancelButtonText: '요청하지 않습니다', width: 1000,
      }).then(async (result) => {
        if (result.isConfirmed) {
          let insReqCxlReserve = await this.$api("/api/insReqCxlReserve", { param: [rCode, this.user.email, "Y"] });
          if (Object.keys(insReqCxlReserve)[0] === 'error') {
            this.$swal.fire('', '요청처리 중 오류가 발생했습니다.<br>온라인 문의 또는 연락(1660-4602)을 주시면 신속하게 처리해드리겠습니다.', 'warning')
          } else {
            this.sendKakao("RCX", rCode)
          }
        }
      })
    },

    async reqCxl_nbus(nCode) {
      let res_supCxl = await this.$api("/api/supCxl_nbus", { param: nCode })
      let supCxl = res_supCxl.length > 0 ? res_supCxl[0] : { supCancellation: "" }
      this.$swal.fire({
        html: "예약취소를 요청하시겠습니까?<br><br><p class='text-start swal-popup'>" + supCxl.supCancellation.split('\n').join('<br>') + "</p>",
        showCancelButton: true, confirmButtonText: '동의하고 요청합니다', cancelButtonText: '요청하지 않습니다', width: 1000,
      }).then(async (result) => {
        if (result.isConfirmed) {
          let insReqCxlReserve = await this.$api("/api/insReqCxlReserve", { param: [nCode, this.user.email, "Y"] });
          if (Object.keys(insReqCxlReserve)[0] === 'error') {
            this.$swal.fire('', '요청처리 중 오류가 발생했습니다.<br>온라인 문의 또는 연락(1660-4602)을 주시면 신속하게 처리해드리겠습니다.', 'warning')
          } else {
            this.sendKakao("RCX", nCode)
          }
        }
      })
    },

    async pgPay(pFlag) {
      let veriSign = "N", payPointAmt = 0, payCouponAmt = 0, payAmount = 0, insVeriData = []
      if (pFlag === "p2") {
        payAmount = this.balance
        insVeriData = await this.$api("/api/proc_setVeriData_1", { param: [this.reserveInfo.reqReserveCode + "-2", payAmount, veriSign, pFlag, payPointAmt, payCouponAmt] });
      } else {
        if (this.ctCode === "nbus") {
          payAmount = this.reserveInfo.nbusPriceTot
          insVeriData = await this.$api("/api/proc_setVeriData", { param: [this.reserveInfo.inqCode, payAmount, veriSign, payPointAmt, payCouponAmt] });
        } else {
          payAmount = this.reserveInfo.cstPrice_new
          insVeriData = await this.$api("/api/proc_setVeriData", { param: [this.reserveInfo.reqReserveCode, payAmount, veriSign, payPointAmt, payCouponAmt] });
        }
      }
      if (insVeriData.affectedRows < 0) { this.$swal.fire("", "검증데이타가 생성되지 않았습니다. 재시도해주세요", "warning"); return false; }
      this.paymentWidget = await loadPaymentWidget(this.clientKey, ANONYMOUS);
      this.paymentMethodWidget = this.paymentWidget.renderPaymentMethods("#payment-method", { value: payAmount }, { variantKey: "DEFAULT" });
      this.showFlag = !this.showFlag
    },

    async requestPayment(rNo, pFlag) {
      let taxFreeAmount = 0, resCode = ""
      if (pFlag === "p2") { taxFreeAmount = this.balance; resCode = rNo + "-2"; }
      else { resCode = rNo }
      taxFreeAmount = (this.ctCode === "nbus") ? this.reserveInfo.nbusPriceTot : this.reserveInfo.cstPrice_new
      try {
        if (this.paymentWidget) {
          await this.paymentWidget.requestPayment({
            orderId: resCode,
            orderName: (this.ctCode === "nbus") ? rNo : this.productInfo.pdtNameKor,
            successUrl: 'https://ntabi.co.kr/success_pg',
            failUrl: 'https://ntabi.co.kr/fail_pg',
            // successUrl: 'http://localhost/success_pg',
            // failUrl: 'http://localhost/fail_pg',
            customerEmail: (this.ctCode === "nbus") ? this.reserveInfo.inqEmail : this.reserveInfo.conEmail,
            customerName: (this.ctCode === "nbus") ? this.reserveInfo.inqName : this.reserveInfo.reqName,
            taxFreeAmount,
          });
        }
      } catch (error) { console.error(error); }
    },

    async freePay(rNo, pFlag) {
      let taxFreeAmount = (pFlag === "p2") ? this.balance : this.reserveInfo.cstPrice_new
      let payByPoint = await this.$api("/api/payByPoint", { param: [this.reserveInfo.reqEmail, this.paidPoint, 'S', this.reqRsvCode, '사용대기'] });
      if (payByPoint.affectedRows < 0) { this.$swal.fire('', '포인트 결제처리 중 오류가 발생하였습니다(코드: payByPoint)<br>포인트 복구문의: 1660-4602', 'error'); return false; }
      let payByUser = await this.$api("/api/payByUser", { param: [taxFreeAmount, this.user.email, '000', rNo] });
      if (payByUser.affectedRows > 0) {
        let upd_UsePoint = await this.$api("/api/upd_UsePoint", { param: [this.user.email, rNo] });
        if (upd_UsePoint.affectedRows < 0 || upd_UsePoint.affectedRows == undefined) {
          this.$swal.fire("", "죄송합니다. 결제처리에 오류가 발생했습니다(코드:upd_UsePoint).<br>문의처: 1660-4602", "warning"); return false;
        } else {
          this.getPayDetailInfo(rNo)
          this.$swal.fire('', '전액 포인트 결제되었습니다. 감사합니다,', 'success');
        }
      } else {
        this.$swal.fire('', '결제처리 중 에러가 발생했습니다(코드: payByUser)<br>문의처(1660-4602)에 확인을 요청해주세요.', 'error'); return false;
      }
    },

    async getPayDetailInfo(orderId) {
      let resNo = orderId
      let payDetailInfo = (this.ctCode === "nbus")
        ? await this.$api("/api/payDetailInfo_nbus", { param: [resNo] })
        : await this.$api("/api/payDetailInfo", { param: [resNo] });
      if (payDetailInfo.length > 0) {
        this.payDetailInfo = payDetailInfo[0];
        this.sendKakao("PY", resNo);
      }
    },

    async getHandlerInfo() {
      let handTel = await handlerInfo(this.$api);
      if (handTel.length > 0) this.handTel = handTel
    },

    async sendKakao(param, resNo) {
      let insKSendHistory = await this.$api("/api/insKSendHistory", { param: [resNo, param, this.reserveInfo.reqTelNo] });
      if (this.ctCode === "nbus") this.handTel.push({ aimCall: this.reserveInfo.inqTel })
      else this.handTel.push({ aimCall: this.reserveInfo.reqTelNo })
      this.handTelCnt = this.handTel.length

      if (insKSendHistory.affectedRows > 0) {
        let promises = []
        if (param == "PY") {
          for (let i = 0; i < this.handTelCnt; i++) {
            let kakaoAlimData = {
              clientName: this.payDetailInfo.clientName, resName: this.payDetailInfo.resName,
              resPaxName: this.payDetailInfo.resPaxName, resPaxCnt: this.payDetailInfo.resPaxCnt,
              dptDate: this.payDetailInfo.dptDate, resPhone: this.payDetailInfo.resPhone,
              resCode: resNo, resPayAmount: this.getCurrencyFormat(this.payDetailInfo.resPayAmount),
              resManager: this.payDetailInfo.resManager, alimFlag: "nonPY", clientCall: this.handTel[i].aimCall,
            };
            promises.push(this.$api("api/kakaoAlimSend2", { param: [{ kakaoAlimData }] }))
          }
          Promise.all(promises).then((results) => {
            console.log(results)
            this.$swal.fire('', '결제완료 알림톡이 발송되었습니다', 'success').then(() => { location.reload(true) })
          }).catch((error) => { console.log("Error calling api: ", error) })
        } else if (param == "RCX") {
          let resPaxCnt = (this.ctCode === "nbus") ? this.reserveInfo.personCnt * 1 : ""
          if (this.ctCode === "nbus") {
            for (let i = 0; i < this.handTelCnt; i++) {
              let kakaoAlimData = {
                inqName: this.reserveInfo.inqName, inqCode: resNo,
                rentStartDate: this.getDateFormat(this.reserveInfo.rentStartDate),
                inqTel: this.reserveInfo.inqTel, alimFlag: "nonRCX",
                clientCall: this.handTel[i].aimCall, memFlag: "N",
              };
              promises.push(this.$api("api/kakaoAlimSend7", { param: [{ kakaoAlimData }] }))
            }
          } else {
            for (let i = 0; i < this.handTelCnt; i++) {
              let kakaoAlimData = {
                clientName: this.reserveInfo.reqName, resName: this.productInfo.pdtNameKor,
                resPaxName: this.reserveInfo.reqName, resPaxCnt,
                dptDate: this.reserveInfo.reqDptDate, resPhone: this.reserveInfo.reqTelNo,
                resCode: resNo, resManager: this.productInfo.handlerNameKor,
                alimFlag: "nonRCX", clientCall: this.handTel[i].aimCall,
              };
              promises.push(this.$api("api/kakaoAlimSend2", { param: [{ kakaoAlimData }] }))
            }
          }
          Promise.all(promises).then((results) => {
            console.log("result:", results)
            this.$swal.fire('', '취소요청 알림톡이 발송되었습니다', 'success').then(() => { })
          }).catch((error) => { console.log("Error calling api: ", error.response ? error.response.data : error); })
        }
      }
    },

    async getReqPayInfo(val) {
      let resCode = ""
      if (this.reserveInfo.partFlag === "1") resCode = val + "-1"
      else if (this.reserveInfo.partFlag === "2") resCode = val + "-1"
      else resCode = val

      let rtnRPflag_tmp = []
      if (this.rpCode === "nonWP") {
        rtnRPflag_tmp = await this.$api("/api/getReqPayInfo_vir", { param: [resCode] });
        let virAccInfo = await this.$api("/api/res_virAccPayInfo", { param: [val] });
        if (virAccInfo.length > 0) this.virAccInfo = virAccInfo[0]
        let accPayStatus = ""
        if ((this.virAccInfo.payStyle === "fu" && this.virAccInfo.payFlag1 === "Y") || (this.virAccInfo.payStyle === "p2" && this.virAccInfo.payFlag2 === "Y"))
          accPayStatus = "결제완료(담당자 확인 중)"
        else if ((this.virAccInfo.payStyle === "p1" && this.virAccInfo.payFlag1 === "Y") || (this.virAccInfo.payStyle === "p2" && this.virAccInfo.payFlag2 === "N"))
          accPayStatus = "잔액입금대기"
        else accPayStatus = "입금대기"
        this.accPayStatus = accPayStatus
      } else if (this.rpCode != "nonWP" && this.ctCode === "nbus") {
        rtnRPflag_tmp = await this.$api("/api/getReqPayInfo_vir", { param: [resCode] });
      } else {
        rtnRPflag_tmp = await this.$api("/api/getReqPayInfo", { param: [resCode] });
      }

      if (rtnRPflag_tmp.length > 0) {
        if (rtnRPflag_tmp[0].reqPayStatus === "CO") this.paidFlag = "Y"
        else if (rtnRPflag_tmp[0].reqPayStatus === "PY" && (rtnRPflag_tmp[0].payFlag === "fu" || rtnRPflag_tmp[0].payFlag === "p2" || rtnRPflag_tmp[0].payFlag == null)) { this.payStyle = "f"; this.paidFlag = "Y"; }
        else if (rtnRPflag_tmp[0].reqPayStatus === "PY" && rtnRPflag_tmp[0].payFlag === "p1") { this.payStyle = "p"; this.paidFlag = "Y"; this.balance = (this.reserveInfo.totalPrice) * 1 - (rtnRPflag_tmp[0].actualPayAmount) * 1 }
        else if (rtnRPflag_tmp[0].reqPayStatus === "RP" && rtnRPflag_tmp[0].payFlag == null) { this.paidFlag = "Y"; this.rtnRPflag = "Y"; }
        else if (rtnRPflag_tmp[0].reqPayStatus === "RP" && rtnRPflag_tmp[0].payFlag === 'p1') { this.paidFlag = "Y"; this.balance = (this.reserveInfo.totalPrice) * 1 - (rtnRPflag_tmp[0].actualPayAmount) * 1 }
        else if (rtnRPflag_tmp[0].reqPayStatus === "RP" && (rtnRPflag_tmp[0].payFlag === 'p2' || rtnRPflag_tmp[0].payFlag === 'fu')) {
          if (rtnRPflag_tmp[0].actualPayAmount != rtnRPflag_tmp[0].reqTotPayAmt) {
            if (this.rpCode === "nonWP") this.$swal.fire("", "가상계좌 입금대기 상태입니다.", "info")
            else if (this.ctCode === "nbus") this.$swal.fire("", "엔버스 결제대기 중입니다.", "info")
            else { this.$swal.fire("", "최종결제금액과 상품대금이 일치하지 않습니다. 실제결제된 금액을 확인해주세요", "question"); return false; }
          } else { this.paidFlag = "Y"; this.rtnRPflag = "Y"; }
        }
        this.rtnRPflag_tmp = rtnRPflag_tmp[0]
        let payPointInfo = await this.$api("/api/payPointInfo", { param: [val] });
        this.payPointAmt = (payPointInfo[0].payPoint > 0) ? payPointInfo[0].payPoint : 0
      } else { this.rtnRPflag = "N"; this.paidFlag = "N"; }

      if (this.paidFlag != "N") {
        this.userPayInfo = rtnRPflag_tmp[0]
        this.p1PayAmt = (this.userPayInfo.p1PayAmt == null) ? 0 : this.userPayInfo.p1PayAmt
        this.p2PayAmt = (this.userPayInfo.p2PayAmt == null) ? 0 : this.userPayInfo.p2PayAmt
        this.p1PayDate = (this.userPayInfo.p1PayDate == null) ? "" : this.getKorDateFormat(this.userPayInfo.p1PayDate)
        this.p2PayDate = (this.userPayInfo.p2PayDate == null) ? "" : this.getKorDateFormat(this.userPayInfo.p2PayDate)
        this.payPointAmt = (this.userPayInfo.payPointAmt == null) ? 0 : this.userPayInfo.payPointAmt
        this.payPointDate = (this.userPayInfo.payPointDate == null) ? "" : this.getKorDateFormat(this.userPayInfo.payPointDate)
        this.totalPay = this.p1PayAmt * 1 + this.p2PayAmt * 1 + this.payPointAmt * 1
      }
      this.fPayFlag = (this.userPayInfo.reqTotPayAmt == this.p1PayAmt) ? "Y" : "N"
    },

    getDatesStartToLast(startDate, lastDate) {
      if (!(startDate && lastDate)) return "Not Date Format";
      let result = [], curDate = new Date(startDate);
      while (curDate <= new Date(lastDate)) { result.push(curDate.toISOString().split("T")[0]); curDate.setDate(curDate.getDate() + 1); }
      return result;
    },

    async getReqProcLevel() {
      let rProc = await this.$api("/api/reqProcLevel", {});
      if (rProc.length > 0) this.rProc = rProc
    },

    async getPdtPromotion_apply() {
      let pdtPromoInfo_apply = await this.$api("/api/pdtPromo_apply", { param: [this.productId, this.reserveInfo.reqDptDate] });
      if (pdtPromoInfo_apply.length > 0) {
        this.pdtPromoInfo_apply = pdtPromoInfo_apply[0];
        if (this.pdtPromoInfo_apply.promoStart) this.pdtPromoInfo_apply.promoStart = this.getDateFormat(this.pdtPromoInfo_apply.promoStart);
        if (this.pdtPromoInfo_apply.promoEnd) this.pdtPromoInfo_apply.promoEnd = this.getDateFormat(this.pdtPromoInfo_apply.promoEnd);
        this.aPromoFlag = "Y"
      }
    },

    async getProductTransInfoExited() {
      let pdtTransInfo1 = await this.$api("/api/pdtTransInfo_existed", { param: [this.productId] });
      if (pdtTransInfo1.length > 0) this.pdtTransInfo1 = pdtTransInfo1[0];
    },

    async getProductPromotion() {
      let productPromotion = await this.$api("/api/productPromotion", { param: [this.productId] });
      if (productPromotion.length > 0) this.productPromotion = productPromotion[0]
      else return false;
    },

    goToList() { this.$router.push({ path: '/myPage' }); },

    // goToCustomerAsk() { this.$router.push({ path: '/customerAsk', query: {} }); },
    // ── 문의하기 (비회원 → 문의처 안내) ──────────────────────
    goToCustomerAsk() {
      this.$swal.fire({
        title: '비회원 문의안내',
        html:
          '<div class="text-center" style="font-size:.88rem;">' +
          '<p>비회원 예약은 온라인 문의 기능을 이용하실 수 없습니다.</p>' +
          '<p>아래 연락처로 문의해 주시면 신속히 도와드리겠습니다.</p>' +
          '</div>' +
          '<p style="font-size:1.1rem; font-weight:700; color:#1a6eb5; margin-top:.8rem;">' +
          '<i class="bi bi-telephone-fill"></i> 1660-4602' +
          '</p>' +
          '<p style="font-size:.8rem; color: peru;">카카오톡 채널로도 문의 가능합니다</p>',
        icon: 'info',
        confirmButtonText: '확인',
      })
    },

    removeDubofArrays(arr1, arr2) { return arr1.concat(arr2).filter(item => !arr1.includes(item) || !arr2.includes(item)); },
  }
}
</script>

<style scoped>
/* =============================================
   CSS Variables - ntabi 브랜드 컬러 (회원용과 동일)
============================================= */
#reserdetail {
  --green:          #86cd53;
  --green-dark:     #5fa033;
  --green-light:    #d4f0b8;
  --green-xlight:   #f0fbe7;
  --charcoal:       #2b3a2b;
  --charcoal-light: #3d5c3d;
  --teal:           #3aab6f;
  --bg:             #f5faf2;
  --border:         #ddefd4;
  --shadow:         rgba(90, 160, 51, 0.10);
  --text-main:      #1a2e1a;
  --text-sub:       #5a7a5a;
  --text-muted:     #8aaa8a;
  --radius:         14px;
  --radius-sm:      8px;
  --white:          #ffffff;
}
.rd-wrap { background: var(--bg); min-height: 100vh; }
.rd-section { padding: 2rem 0 5rem; }
@media (max-width: 991px) { .rd-section { padding: 1rem 0 4rem; } }
#reserdetail .pc     { display: block; }
#reserdetail .mobile { display: none;  }
@media (max-width: 991px) { #reserdetail .pc { display: none; } #reserdetail .mobile { display: block; } }

/* 페이지 헤더 */
.rd-page-header { text-align: center; padding: 2.5rem 0 2rem; }
.rd-header-badge { display: inline-flex; align-items: center; gap: .4rem; background: var(--green-light); color: var(--green-dark); font-size: .72rem; font-weight: 700; letter-spacing: .12em; padding: .28rem .9rem; border-radius: 20px; margin-bottom: .8rem; }
.rd-page-title { font-size: 1.8rem; font-weight: 700; color: var(--charcoal); margin: 0 0 .4rem; }
.rd-page-sub   { font-size: .88rem; color: var(--text-sub); margin: 0; }
@media (max-width: 991px) { .rd-page-title { font-size: 1.4rem; } .rd-page-header { padding: 4rem 0 1rem; } }

/* 카드 공통 */
.rd-card { background: var(--white); border: 1px solid var(--border); border-radius: var(--radius); box-shadow: 0 2px 16px var(--shadow); margin-bottom: 1.5rem; overflow: hidden; }
.rd-card-header { display: flex; align-items: center; gap: .6rem; background: var(--charcoal); color: var(--white); padding: .85rem 1.4rem; font-size: .95rem; font-weight: 600; }
.rd-card-header i { color: var(--green-light); font-size: 1.05rem; }
.rd-card-body { padding: 1.6rem; }
@media (max-width: 991px) { .rd-card-body { padding: 1.1rem; } }

/* 상품 헤더 */
.rd-product-card .rd-card-body { padding: 0; }
.rd-product-header { display: flex; }
.rd-product-img-wrap { flex: 0 0 260px; }
.rd-product-img { width: 100%; height: 220px; object-fit: cover; display: block; }
.rd-product-img-placeholder { width: 100%; height: 220px; display: flex; align-items: center; justify-content: center; background: var(--green-xlight); font-size: 3rem; }
.rd-product-meta { flex: 1; padding: 1.4rem 1.6rem; display: flex; flex-direction: column; justify-content: space-between; }
.rd-product-code { font-size: .72rem; color: var(--text-muted); font-weight: 500; letter-spacing: .04em; display: block; margin-bottom: .3rem; }
.rd-product-name { font-size: 1.2rem; font-weight: 700; color: var(--charcoal); margin: 0 0 .6rem; line-height: 1.4; }
.rd-reserve-code-wrap { display: flex; align-items: center; gap: .5rem; }
.rd-reserve-code { font-size: 1rem; font-weight: 700; color: var(--green-dark); }
.rd-nbus-header { display: flex; align-items: center; gap: 1.2rem; padding: 1.6rem; flex-wrap: wrap; }
.rd-nbus-icon { width: 56px; height: 56px; background: var(--green-xlight); border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 1.5rem; color: var(--green-dark); flex-shrink: 0; }
.rd-nbus-info { flex: 1; }
.rd-nbus-code { font-size: 1.1rem; font-weight: 700; color: var(--green-dark); margin: 0; }
.rd-label { font-size: .72rem; color: var(--text-muted); font-weight: 600; margin: 0 0 .2rem; }
@media (max-width: 991px) { .rd-product-header { flex-direction: column; } .rd-product-img-wrap { flex: unset; width: 100%; } .rd-product-img { height: 180px; } .rd-product-meta { padding: 1rem; } }

/* 정보 그리드 (PC) */
.rd-info-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 1rem; }
.rd-info-item { display: flex; flex-direction: column; gap: .35rem; padding: .9rem 1rem; background: var(--green-xlight); border-radius: var(--radius-sm); border: 1px solid var(--border); }
.rd-info-item--full { grid-column: 1 / -1; }
.rd-info-label { font-size: .73rem; font-weight: 600; color: var(--text-sub); text-transform: uppercase; letter-spacing: .04em; }
.rd-info-value { font-size: .9rem; color: var(--text-main); font-weight: 500; line-height: 1.5; }
.rd-days { font-size: .8rem; color: var(--text-sub); font-style: normal; }
.rd-flight-detail { font-size: .78rem; color: var(--text-sub); }
.rd-mt { margin-top: 1rem; }
@media (max-width: 767px) { .rd-info-grid { grid-template-columns: 1fr; } }

/* 정보 리스트 (모바일) */
.rd-info-list { display: flex; flex-direction: column; }
.rd-info-row { display: flex; align-items: center; justify-content: space-between; padding: .75rem .2rem; border-bottom: 1px solid var(--border); gap: .5rem; }
.rd-info-row:last-child { border-bottom: none; }
.rd-info-row .rd-info-label { flex: 0 0 auto; min-width: 95px; font-size: .75rem; color: var(--text-sub); font-weight: 600; }
.rd-info-row .rd-info-value { text-align: right; font-size: .85rem; color: var(--text-main); }
.rd-info-row--col { flex-direction: column; align-items: flex-start; gap: .4rem; }
.rd-info-row--col .rd-info-value, .rd-info-row--col .rd-info-label { text-align: left; }

/* Textarea */
.rd-textarea { width: 100%; min-height: 80px; border: 1px solid var(--border); border-radius: var(--radius-sm); padding: .6rem .8rem; font-size: .82rem; color: var(--text-main); background: var(--white); resize: vertical; outline: none; }

/* 상태 배지 */
.rd-status-wrap { display: flex; flex-direction: column; gap: .35rem; align-items: flex-start; }
.rd-status-badge { display: inline-flex; align-items: center; font-size: .78rem; font-weight: 600; padding: .28rem .75rem; border-radius: 20px; }
.rd-status--paid    { background: #fff3e0; color: #e65100; }
.rd-status--partial { background: #fff8e1; color: #f57c00; }
.rd-status--request { background: #e3f2fd; color: #1565c0; }
.rd-status--cancel  { background: #fce4ec; color: #b71c1c; }
.rd-status-text { font-size: .85rem; color: var(--text-main); }
.rd-account-badge { font-size: .72rem; font-weight: 500; color: var(--text-sub); margin-left: .3rem; }
.rd-cxl-btn { background: transparent; border: 1.5px solid #e53935; color: #e53935; font-size: .78rem; font-weight: 600; padding: .3rem .9rem; border-radius: var(--radius-sm); cursor: pointer; transition: all .15s; margin-top: .3rem; }
.rd-cxl-btn:hover:not(:disabled) { background: #ffebee; }
.rd-cxl-btn:disabled { border-color: #aaa; color: #aaa; cursor: not-allowed; }

/* 섹션 서브 타이틀 */
.rd-section-sub-title { display: flex; align-items: center; gap: .4rem; font-size: .82rem; font-weight: 700; color: var(--charcoal); margin: 0 0 .7rem; }
.rd-section-sub-title i { color: var(--green-dark); }

/* 경로 아이템 (엔버스) */
.rd-route-section { margin-top: 1.2rem; }
.rd-route-item { display: flex; align-items: center; gap: .8rem; padding: .65rem 1rem; background: var(--green-xlight); border-radius: var(--radius-sm); border: 1px solid var(--border); margin-bottom: .5rem; flex-wrap: wrap; }
.rd-route-day { background: var(--charcoal); color: var(--white); font-size: .72rem; font-weight: 700; padding: .2rem .6rem; border-radius: 20px; flex-shrink: 0; }
.rd-route-points { display: flex; align-items: center; gap: .4rem; flex: 1; flex-wrap: wrap; }
.rd-route-dept { color: #1565c0; font-weight: 600; font-size: .85rem; }
.rd-route-via  { color: var(--green-dark); font-weight: 600; font-size: .85rem; }
.rd-route-arr  { color: #c62828; font-weight: 600; font-size: .85rem; }
.rd-route-arrow { color: var(--text-muted); font-size: .75rem; }
.rd-route-time { font-size: .78rem; color: var(--text-sub); flex-shrink: 0; }
.rd-route-item-mo { margin-top: .5rem; }
.rd-route-day-mo { font-size: .78rem; font-weight: 700; color: var(--charcoal); margin-bottom: .3rem; }
.rd-route-mo-grid { display: grid; grid-template-columns: 45px 1fr; gap: .2rem .5rem; font-size: .8rem; background: var(--green-xlight); padding: .6rem; border-radius: var(--radius-sm); border: 1px solid var(--border); }
.rd-route-mo-label { color: var(--text-sub); font-weight: 600; font-size: .72rem; }

/* 옵션 섹션 */
.rd-option-section { display: grid; grid-template-columns: repeat(2, 1fr); gap: 1rem; margin-top: 1.2rem; }
.rd-option-box { background: var(--green-xlight); border: 1px solid var(--border); border-radius: var(--radius-sm); padding: 1rem; }
.rd-option-box--full { grid-column: 1 / -1; }
.rd-option-item { display: flex; align-items: center; gap: .5rem; padding: .4rem 0; border-bottom: 1px dashed var(--border); font-size: .85rem; }
.rd-option-item:last-child { border-bottom: none; }
.rd-option-name  { flex: 1; color: var(--text-main); }
.rd-option-qty   { color: var(--text-sub); font-size: .78rem; }
.rd-option-price { margin-left: auto; }
.rd-empty-text   { font-size: .82rem; color: var(--text-muted); }
.rd-option-item-mo { font-size: .82rem; color: var(--text-main); padding: .25rem 0; }
.rd-person-price { font-size: .85rem; }
@media (max-width: 767px) { .rd-option-section { grid-template-columns: 1fr; } }

/* 결제 정보 */
.rd-pay-summary { display: flex; flex-direction: column; gap: .5rem; padding: 1rem 1.2rem; background: var(--green-xlight); border-radius: var(--radius-sm); border: 1px solid var(--border); margin-bottom: 1rem; }
.rd-pay-row { display: flex; justify-content: space-between; align-items: center; }
.rd-pay-row--total { border-top: 1.5px solid var(--border); padding-top: .7rem; margin-top: .2rem; }
.rd-pay-label { font-size: .85rem; color: var(--text-sub); font-weight: 600; }
.rd-pay-value { font-size: .9rem; color: var(--text-main); font-weight: 600; }
.rd-pay-value--discount { color: #1565c0; font-weight: 600; }
.rd-pay-value--total { font-size: 1.7rem; font-weight: 700; color: #c62828; line-height: 1; }
.rd-pay-value--total em { font-style: normal; font-size: 1rem; margin-left: .15rem; }
.rd-pay-history { background: var(--green-xlight); border: 1px solid var(--border); border-radius: var(--radius-sm); padding: .9rem 1.1rem; margin-bottom: 1rem; }
.rd-pay-history-title { font-size: .75rem; font-weight: 700; color: var(--text-sub); letter-spacing: .06em; text-transform: uppercase; margin: 0 0 .6rem; }
.rd-pay-history-item { display: flex; justify-content: space-between; align-items: center; font-size: .83rem; padding: .32rem 0; border-bottom: 1px dashed var(--border); color: var(--text-main); gap: .5rem; }
.rd-pay-history-item:last-child { border-bottom: none; }
.rd-pay-history-item small { color: var(--text-muted); }
.rd-pay-detail-grid { display: grid; grid-template-columns: 1fr 300px; gap: 1.5rem; align-items: start; }
.rd-pay-btn-wrap { margin: 1.2rem 0 .5rem; text-align: right; }
.rd-pay-btn { display: inline-flex; align-items: center; gap: .4rem; background: var(--green-dark); color: var(--white); border: none; border-radius: var(--radius-sm); padding: .75rem 2rem; font-size: 1rem; font-weight: 700; cursor: pointer; transition: background .2s, transform .15s; }
.rd-pay-btn:hover     { background: var(--charcoal); transform: translateY(-2px); }
.rd-pay-btn--free     { background: var(--teal); }
.rd-pay-btn--free:hover { background: #2e8a58; }
.rd-pay-btn--balance  { background: #1565c0; }
.rd-pay-btn--balance:hover { background: #0d47a1; }
.rd-bank-info { background: #fff8e1; border: 1px solid #ffe082; border-radius: var(--radius-sm); padding: 1rem 1.2rem; margin-top: 1.2rem; }
.rd-bank-title   { font-size: .85rem; font-weight: 700; color: #5d4037; margin: 0 0 .5rem; }
.rd-bank-text    { font-size: .82rem; color: #5d4037; margin: 0 0 .4rem; }
.rd-bank-account { font-size: .9rem; font-weight: 700; color: #2e7d32; margin: .4rem 0; }
.rd-bank-sub     { font-size: .78rem; color: #795548; margin: .2rem 0 0; }

@media (max-width: 767px) {
  .rd-pay-detail-grid { grid-template-columns: 1fr; }
  .rd-pay-btn { width: 100%; justify-content: center; }
}
@media (max-width: 768px) { .searchNonRes { font-size: 1rem; vertical-align: middle; } }
.swal-popup { font-size: .85rem; overflow: hidden; word-wrap: break-word; }

/* 액션 버튼 (호텔 헤더 문의하기) */
.rd-action-btn {
  display: inline-flex; align-items: center; gap: .3rem;
  font-size: .8rem; font-weight: 600; color: var(--white);
  background: var(--green-dark); border: none;
  border-radius: var(--radius-sm); padding: .42rem .9rem;
  cursor: pointer; transition: background .2s, transform .1s;
}
.rd-action-btn:hover { background: var(--charcoal); transform: translateY(-1px); }

/* 호텔 상태 배지 */
.status-badge-h { display: inline-block; font-size: 0.72rem; font-weight: 600; padding: 2px 10px; border-radius: 20px; }
.status-h-wait   { background: #fffbe6; color: #b07d00; }
.status-h-done   { background: #e6f4ea; color: #2d6a4f; }
.status-h-cancel { background: #f4f4f4; color: #aaa; }
.status-h-danger { background: #fff0f0; color: #e63946; }

/* 하단 버튼 */
.rd-footer-btns { display: flex; gap: 1rem; justify-content: center; padding: 1.5rem 0 2rem; flex-wrap: wrap; }
.rd-footer-btn { display: inline-flex; align-items: center; gap: .4rem; padding: .75rem 2rem; font-size: .95rem; font-weight: 600; border-radius: var(--radius-sm); cursor: pointer; border: none; transition: background .2s, transform .15s; min-width: 160px; justify-content: center; }
.rd-footer-btn--main { background: var(--charcoal); color: var(--white); }
.rd-footer-btn--main:hover { background: var(--charcoal-light, #3d5c3d); transform: translateY(-2px); }
.rd-footer-btn--cancel { background: #b71c1c; color: var(--white); }
.rd-footer-btn--cancel:hover:not(:disabled) { background: #c62828; transform: translateY(-2px); }
.rd-footer-btn--cancel:disabled { background: #aaa; cursor: not-allowed; }
@media (max-width: 767px) { .rd-footer-btns { flex-direction: column; padding: 1rem; } .rd-footer-btn { width: 100%; } }
</style>